import { ChangeDetectorRef, Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators, Validator, FormControl } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { ConfiguracionInicialService } from 'src/app/services/configuracioninicial.service';
import { MenuService } from 'src/app/services/menu.service';
import { UtilitariosService } from 'src/app/services/utilitarios.service';
import { ConfiguracionService } from '../../services/configuracion.service';
import { RespuestaGenerica } from '../../models/generic/RespuestaGenerica';
import { ConfirmacionGenericaComponent } from '../confirmaciongenerica/confirmaciongenerica.component';
import { TamanoAppService } from 'src/app/services/tamanoapp.service';
import {MatPaginator} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import { Maestro_EstadoActualizar } from 'src/app/models/generic/Maestro_EstadoActualizar';
import { ModificarPlantillaComponent } from '../modificar-plantilla/modificar-plantilla.component';
import { Maestros_ProductosService } from 'src/app/services/maestros_productos.service';
import { Maestro_Productos } from 'src/app/models/generic/Maestro_Productos';
import { Maestro_Productos_Actualizacion } from 'src/app/models/generic/Maestro_Productos_Actualizacion';
import { Listas } from 'src/app/models/generic/Listas';
import { Maestro_ProductosPlazos } from 'src/app/models/generic/Maestro_ProductosPlazos';
import { MatTableDataSource } from '@angular/material/table';
import { Maestro_ProductosEdades } from 'src/app/models/generic/Maestro_ProductosEdades';
import { Maestro_ProductosCodigosActivacion } from 'src/app/models/generic/Maestro_ProductosCodigosActivacion';
import { Maestro_ProductosFirmaElectronica } from 'src/app/models/generic/Maestro_ProductosFirmaElectronica';
import { Maestro_ProductosExpedientes } from 'src/app/models/generic/Maestro_ProductosExpedientes';
import { Maestro_ProductosEstadosDias } from 'src/app/models/generic/Maestro_ProductosEstadosDias';
import { SeleccionarArchivoComponent } from '../seleccionararchivo/seleccionararchivo.component';
import { Maestro_ProductosFirmaElectronicaCampos } from 'src/app/models/generic/Maestro_ProductosFirmaElectronicacampos';
import { Maestro_ProductosFirmaElectronicaCamposUbicacion } from 'src/app/models/generic/Maestro_ProductosFirmaElectronicacamposubicacion';
import { MatDialog } from '@angular/material/dialog';
import { Maestros_ConfiguracionComercializacionService } from 'src/app/services/maestros_configuracioncomercializacion.service';
import { Maestro_ConfiguracionComercializacionDetalle } from 'src/app/models/generic/Maestro_ConfiguracionComercializacionDetalle';
import { Maestro_ProductosCamposBeneficiarios } from 'src/app/models/generic/Maestro_ProductosCamposBeneficiarios';
import { Maestro_ProductosCampos } from 'src/app/models/generic/Maestro_ProductosCampos';
import { Maestro_ProductosNotificaciones } from 'src/app/models/generic/Maestro_ProductosNotificaciones';

@Component({
  selector: 'maestros-productos-editar',
  templateUrl: './maestros-productos-editar.component.html',
  styleUrls: ['./maestros-productos-editar.component.scss']
})
export class MaestrosProductosEditarComponent implements OnInit{
  
  form: FormGroup;
  formConsulta: FormGroup;
  tituloForma: string = 'Programas';
  tituloBoton: string = 'Guardar';
  mostrarCargando: boolean = false;
  codigoAccion: string = '';
  codigoAccionActualizacion: string = '';
  @ViewChild('appconfirmacion', {static: false}) _appconfirmacion: ConfirmacionGenericaComponent;
  @ViewChild('uploadFile', {static: false}) _uploadFile: ElementRef;
  @ViewChild('cargararchivofirmaelectronica', {static: false}) _cargararchivofirmaelectronica: SeleccionarArchivoComponent;
  @ViewChild('modalfirmaelectronicacampos', {static: false}) _ModalFirmaElectronicaCampos: TemplateRef<any>;
  @ViewChild('modalfirmaelectronicacamposubicacion', {static: false}) _ModalFirmaElectronicaCamposUbicacion: TemplateRef<any>;
  @ViewChild('modificarplantillahtml', {static: false}) _modificarplantillahtml: ModificarPlantillaComponent;
  listasCompletas: Listas[] = [];
  listasAliados: Listas[] = [];
  listasCanales: Listas[] = [];
  listasCanalesSeleccion: Listas[] = [];
  listasComercializacion: Listas[] = [];
  listasTipoVinculacion: Listas[] = [];
  listasImpuestos: Listas[] = [];
  listasProductos: Listas[] = [];
  listasProgramasExpedientes: Listas[] = [];
  listasServiciosExpedientes: Listas[] = [];
  listasSubServiciosExpedientes: Listas[] = [];
  listasSubServiciosExpedientesFiltrada: Listas[] = [];
  listasFirmaElectronicaConfiguracion: Listas[] = [];
  listaTopicosCamposAdicionales: Listas[] = [];
  listaTipoDescargaFirmaElectronica: Listas[] = [];
  listaTipoProceso: Listas[] = [];

  listasTipoCampos: Listas[] = [];
  listasTipoCodigoOPT: Listas[] = [];
  listasFirmaElectronicaFuente: Listas[] = [];
  listasEstado: Maestro_EstadoActualizar[] = [];
  listasEstadosConfiguracion: Listas[] = [];
  listaCondicionSiNo: Maestro_EstadoActualizar[] = [];
  tabItemSeleccionadoAnterior: string = '';
  tabItemSeleccionado: string = 'tabInformacion';

  detalleSeleccionadoPlazos: number;
  detalleSeleccionadoEdades: number;
  detalleSeleccionadoFirmaElectronica: number;
  detalleSeleccionadoFirmaElectronicaCampos: number;
  detalleSeleccionadoFirmaElectronicaCamposUbicacion: number;
  detalleSeleccionadoCodigosActivacion: number;
  detalleSeleccionadoExpedientes: number;
  detalleSeleccionadoEstadosDias: number;
  detalleSeleccionadoCampos: number;
  detalleSeleccionadoCamposBeneficiarios: number;
  detalleSeleccionadoNotificaciones: number;
  formPlazos: FormGroup;
  formEdades: FormGroup;
  formFirmaElectronica: FormGroup;
  formFirmaElectronicaCampos: FormGroup;
  formFirmaElectronicaCamposUbicacion: FormGroup;
  formFirmaElectronicaCamposCopiar: FormGroup;
  formCodigosActivacion: FormGroup;
  formExpedientes: FormGroup;
  formEstadosDias: FormGroup;
  formCampos: FormGroup;
  formCamposBeneficiarios: FormGroup;
  formNotificaciones: FormGroup;
  editarRegistroPlazos: boolean = false;
  editarRegistroEdades: boolean = false;
  editarRegistroFirmaElectronica: boolean = false;
  editarRegistroFirmaElectronicaCampos: boolean = false;
  editarRegistroFirmaElectronicaCamposUbicacion: boolean = false;
  editarRegistroFirmaElectronicaCopiar: boolean = false;
  editarRegistroCodigosActivacion: boolean = false;
  editarRegistroExpedientes: boolean = false;
  editarRegistroEstadosDias: boolean = false;
  editarRegistroCampos: boolean = false;
  editarRegistroCamposBeneficiarios: boolean = false;
  editarRegistroNotificaciones: boolean = false;
  @ViewChild('paginatorplazos') paginatorplazos: MatPaginator;
  @ViewChild('paginatoredades') paginatoredades: MatPaginator;
  @ViewChild('paginatorfirmaeletronica') paginatorfirmaeletronica: MatPaginator;
  @ViewChild('paginatorfirmaeletronicacampos') paginatorfirmaeletronicacampos: MatPaginator;
  @ViewChild('paginatorfirmaeletronicacamposubicacion') paginatorfirmaeletronicacamposubicacion: MatPaginator;
  @ViewChild('paginatorcodigos') paginatorcodigos: MatPaginator;
  @ViewChild('paginatorexpedientes') paginatorexpedientes: MatPaginator;
  @ViewChild('paginatorestadosdias') paginatorestadosdias: MatPaginator;
  @ViewChild('paginatorcampos') paginatorcampos: MatPaginator;
  @ViewChild('paginatorcamposbeneficiarios') paginatorcamposbeneficiarios: MatPaginator;
  @ViewChild('paginatornotificaciones') paginatornotificaciones: MatPaginator;
  @ViewChild(MatSort) sortplazos: MatSort;
  @ViewChild(MatSort) sortedades: MatSort;
  @ViewChild(MatSort) sortfirmaelectronica: MatSort;
  @ViewChild(MatSort) sortfirmaelectronicacampos: MatSort;
  @ViewChild(MatSort) sortfirmaelectronicacamposubicacion: MatSort;
  @ViewChild(MatSort) sortcodigos: MatSort;
  @ViewChild(MatSort) sortexpedientes: MatSort;
  @ViewChild(MatSort) sortestadosdias: MatSort;
  @ViewChild(MatSort) sortcampos: MatSort;
  @ViewChild(MatSort) sortcamposbeneficiarios: MatSort;
  @ViewChild(MatSort) sortnotificaciones: MatSort;
  dataSourcePlazos: MatTableDataSource<Maestro_ProductosPlazos>;
  dataSourceEdades: MatTableDataSource<Maestro_ProductosEdades>;
  dataSourceFirmaElectronica: MatTableDataSource<Maestro_ProductosFirmaElectronica>;
  dataSourceFirmaElectronicacampos: MatTableDataSource<Maestro_ProductosFirmaElectronicaCampos>;
  dataSourceFirmaElectronicacamposubicacion: MatTableDataSource<Maestro_ProductosFirmaElectronicaCamposUbicacion>;
  dataSourceCodigosActivacion: MatTableDataSource<Maestro_ProductosCodigosActivacion>;
  dataSourceExpedientes: MatTableDataSource<Maestro_ProductosExpedientes>;
  dataSourceEstadosDias: MatTableDataSource<Maestro_ProductosEstadosDias>;
  dataSourceCampos: MatTableDataSource<Maestro_ProductosCampos>;
  dataSourceCamposBeneficiarios: MatTableDataSource<Maestro_ProductosCamposBeneficiarios>;
  dataSourceNotificaciones: MatTableDataSource<Maestro_ProductosNotificaciones>;
  columnasEncabezadoPlazos: string[] = ['id', 'habilitado', 'descripcion', 'plazoMeses', 'montobase', 'precio', 'total', 'acciones'];
  columnasEncabezadoEdades: string[] = ['id', 'habilitado', 'descripcion', 'inicio', 'fin', 'precio', 'acciones'];
  columnasEncabezadoFirmaElectronica: string[] = ['id', 'descripcion', 'habilitado', 'rutaArchivoFirmaElectronica', 'nombreDocumentoFirmaElectronica', 'acciones'];
  columnasEncabezadoFirmaElectronicaCampos: string[] = ['tipoCampo', 'campo', 'descripcion', 'orden', 'habilitado', 'mostrar', 'acciones'];
  columnasEncabezadoFirmaElectronicaCamposUbicacion: string[] = ['posicionX', 'posicionY', 'ancho', 'tamanoLetra', 'acciones'];
  columnasEncabezadoCodigosActivacion: string[] = ['id', 'habilitado', 'codigo', 'acciones'];
  columnasEncabezadoExpedientes: string[] = ['id', 'servicio', 'subServicio', 'habilitado','eventosIncluidos','montoMaximoCobertura', 'acciones'];
  columnasEncabezadoEstadosDias: string[] = ['id', 'dia', 'estado', 'acciones'];
  columnasEncabezadoCampos: string[] = ['descripcion', 'mostrar', 'habilitado', 'acciones'];
  columnasEncabezadoCamposBeneficiarios: string[] = ['codigo', 'descripcion', 'origenPadre', 'orden', 'acciones'];
  columnasEncabezadoNotificaciones: string[] = ['id', 'descripcionTipoProceso', 'enviarSMS', 'enviarEmail', 'activo', 'acciones'];
  listaDatosPlazos: Maestro_ProductosPlazos[] = [];
  listaDatosPlazosEliminar: Maestro_ProductosPlazos[] = [];
  listaDatosEdades: Maestro_ProductosEdades[] = [];
  listaDatosEdadesEliminar: Maestro_ProductosEdades[] = [];
  listaDatosFirmaElectronica: Maestro_ProductosFirmaElectronica[] = [];
  listaDatosFirmaElectronicaEliminar: Maestro_ProductosFirmaElectronica[] = [];
  listaDatosCodigosActivacion: Maestro_ProductosCodigosActivacion[] = [];
  listaDatosCodigosActivacionEliminar: Maestro_ProductosCodigosActivacion[] = [];
  listaDatosExpedientes: Maestro_ProductosExpedientes[] = [];
  listaDatosExpedientesEliminar: Maestro_ProductosExpedientes[] = [];
  listaDatosEstadosDias: Maestro_ProductosEstadosDias[] = [];
  listaDatosEstadosDiasEliminar: Maestro_ProductosEstadosDias[] = [];
  listaDatosCampos: Maestro_ProductosCampos[] = [];
  listaDatosCamposEliminar: Maestro_ProductosCampos[] = [];
  listaDatosCamposBeneficiarios: Maestro_ProductosCamposBeneficiarios[] = [];
  listaDatosCamposBeneficiariosEliminar: Maestro_ProductosCamposBeneficiarios[] = [];
  listaDatosNotificaciones: Maestro_ProductosNotificaciones[] = [];
  listaDatosNotificacionesEliminar: Maestro_ProductosNotificaciones[] = [];
  parametrosPrincipal: Maestro_Productos;
  cambiarValores: boolean = true;
  datosArchivo: FormData;
  FiltroArchivos: string = '.txt, .csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel';
  FiltroArchivosFirmaElectronica: string = '.pdf';
  datosArchivoFirmaElectronica: FormData;
  itemFirmaElectronicaSeleccionado: Maestro_ProductosFirmaElectronica;
  itemFirmaElectronicaCamposSeleccionado: Maestro_ProductosFirmaElectronicaCampos;
  listasCampos: Listas[] = [];
  listasCamposBeneficiarios: Listas[] = [];
  
  constructor(public router: Router,
    public fb: FormBuilder,
    public cd: ChangeDetectorRef,
    public snackbar: MatSnackBar,
    public utilitariosService: UtilitariosService,
    public configuracionInicialService: ConfiguracionInicialService,
    public menuService: MenuService,
    public datosServices: Maestros_ProductosService,
    public datosConfiguracionComercializacion: Maestros_ConfiguracionComercializacionService,
    public configuracionService: ConfiguracionService,
    public tamanoAppService: TamanoAppService,
    public modal: MatDialog) {}

  ngOnInit() {
    this.IniciarFormulario();
    this.listaCondicionSiNo = [];
    this.listasEstado = [];
    this.listasCampos = [];
    this.listasCamposBeneficiarios = [];
    this.listaTipoProceso = [];

    this.listaCondicionSiNo.push({ seleccionado: true, descripcion: 'Si' });
    this.listaCondicionSiNo.push({ seleccionado: false, descripcion: 'No' });

    this.listasEstado.push({ seleccionado: true, descripcion: 'Activo' });
    this.listasEstado.push({ seleccionado: false, descripcion: 'Inactivo' });

    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'PERIODOPAGO', 'Periodo pago');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'TIPOIDENTIFICACION', 'Tipo identificación');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'FECHAEXPEDICIONDOCUMENTO', 'Fecha expedición documento');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'LUGAREXPEDICIONDOCUMENTO', 'Lugar expedición documento');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'DIRECCION', 'Dirección');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'CIUDAD', 'Ciudad');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'BARRIO', 'Bario');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'NROPISOS', 'Nro pisos');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'GENERO', 'Género');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'TIPORIESGO', 'Tipo riesgo');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'TIPOPLAN', 'Tipo plan');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'PLAN', 'Plan');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'TIPOASEGURADO', 'Tipo asegurado');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'NROIDENTIFICACIONPAGADOR', 'Nro identificación pagador');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'OBSERVACIONES', 'Observaciones');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'PARTICIPACIONBENEFICIARIO', 'Participación beneficiario');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'MARCA', 'Marca');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'REFERENCIA', 'Referencia');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'NROFIJO', 'Nro fijo');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'NRODOCUMENTOTOMADOR', 'Nro identificación tomador');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'NOMBRETOMADOR', 'Nombre tomador');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'APELLIDOTOMADOR', 'Apellido tomador');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'FECHANACIMIENTOTOMADOR', 'Fecha nacimiento tomador');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'NROMOVILTOMADOR', 'Nro movil tomador');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'NROFIJOTOMADOR', 'Nro fijo tomador');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'EMAILTOMADOR', 'Email tomador');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'DIRECCIONTOMADOR', 'Dirección tomador');
    this.listasCampos = this.itemListaActualizar(this.listasCampos, 'CIUDADTOMADOR', 'Ciudad tomador');

    this.listasCamposBeneficiarios = this.itemListaActualizar(this.listasCamposBeneficiarios, 'tipoIdentificacion', 'Tipo identificación');
    this.listasCamposBeneficiarios = this.itemListaActualizar(this.listasCamposBeneficiarios, 'nroDocumento', 'Nro documento');
    this.listasCamposBeneficiarios = this.itemListaActualizar(this.listasCamposBeneficiarios, 'tipoBeneficiario', 'Tipo beneficiario');
    this.listasCamposBeneficiarios = this.itemListaActualizar(this.listasCamposBeneficiarios, 'nombres', 'Nombres');
    this.listasCamposBeneficiarios = this.itemListaActualizar(this.listasCamposBeneficiarios, 'apellidos', 'Apellidos');
    this.listasCamposBeneficiarios = this.itemListaActualizar(this.listasCamposBeneficiarios, 'raza', 'Raza');
    this.listasCamposBeneficiarios = this.itemListaActualizar(this.listasCamposBeneficiarios, 'nacimiento', 'Nacimiento');
    this.listasCamposBeneficiarios = this.itemListaActualizar(this.listasCamposBeneficiarios, 'edad', 'Edad');
    this.listasCamposBeneficiarios = this.itemListaActualizar(this.listasCamposBeneficiarios, 'color', 'Color');
    this.listasCamposBeneficiarios = this.itemListaActualizar(this.listasCamposBeneficiarios, 'genero', 'Género');
    this.listasCamposBeneficiarios = this.itemListaActualizar(this.listasCamposBeneficiarios, 'parentesco', 'Parentesco');
    this.listasCamposBeneficiarios = this.itemListaActualizar(this.listasCamposBeneficiarios, 'participacion', 'Participación');

    this.listaTipoProceso.push(this.CrearItemProceso('R', 'Registrar'));
    this.listaTipoProceso.push(this.CrearItemProceso('E', 'Cambiar estado'));
    this.listaTipoProceso.push(this.CrearItemProceso('A', 'Activación asistencia'));
    this.listaTipoProceso.push(this.CrearItemProceso('C', 'Registro carga masiva'));
    this.listaTipoProceso.push(this.CrearItemProceso('U', 'Firma electrónica código autorización'));
    this.listaTipoProceso.push(this.CrearItemProceso('F', 'Firma electrónica documento'));
  }
  ngAfterViewInit() {
    this.utilitariosService.EstablecerTextoPaginado(this.paginatorplazos);
    this.utilitariosService.EstablecerTextoPaginado(this.paginatoredades);
    this.utilitariosService.EstablecerTextoPaginado(this.paginatorfirmaeletronica);
    this.utilitariosService.EstablecerTextoPaginado(this.paginatorcodigos);
    this.utilitariosService.EstablecerTextoPaginado(this.paginatorexpedientes);
    this.utilitariosService.EstablecerTextoPaginado(this.paginatorestadosdias);
    this.utilitariosService.EstablecerTextoPaginado(this.paginatorcampos);
    this.utilitariosService.EstablecerTextoPaginado(this.paginatorcamposbeneficiarios);

    console.log('parametros', this.menuService.ParametrosAdicionales);
    if (this.utilitariosService.VerificarContieneDatosTexto(this.menuService.ParametrosAdicionales)) {
      this.parametrosPrincipal = JSON.parse(this.menuService.ParametrosAdicionales);
      if (this.utilitariosService.VerificarContieneDatos(this.parametrosPrincipal)) {
        // console.log('setea valor', this.parametrosPrincipal);
        this.form.setValue(this.parametrosPrincipal);
      }
    }

    if (!this.utilitariosService.VerificarContieneDatos(this.parametrosPrincipal)) {
      this.parametrosPrincipal = new Maestro_Productos();
      console.log('establecer nuevo producto');
    }
    
    this.EstablecerDatosAdicionalesRequeridos();
    
    this.tituloForma = 'Edición de programa';
    this.tituloBoton = 'Guardar';

    this.ConsultarAliados();
    if (this.utilitariosService.VerificarContieneDatosNumerico(this.form.get('aliado').value)) {
      this.ConsultarListas();
    }
    this.ConsultarRegistrosPlazos();
    this.ConsultarRegistrosEdades();
    this.ConsultarRegistrosFirmaElectronica();
    this.ConsultarRegistrosCodigosActivacion();
    this.ConsultarRegistrosExpedientes();
    this.ConsultarRegistrosEstadosDias();
    this.ConsultarRegistrosCampos();
    this.ConsultarRegistrosCamposBeneficiarios();
    this.ConsultarRegistrosNotificaciones();
  }
  CrearItemProceso(tipoProceso: string, descripcion: string): Listas {
    let itemRetorno: Listas = new Listas();
    itemRetorno.codigo = tipoProceso;
    itemRetorno.descripcion = descripcion;
    return itemRetorno;
  }
  itemListaActualizar(listas: Listas[], codigo: string, descripcion: string): Listas[] {
    let itemAgregar: Listas = new Listas();
    itemAgregar.codigo = codigo;
    itemAgregar.descripcion = descripcion;
    listas.push(itemAgregar);

    return listas;
  }

  IniciarFormulario() {
    this.form = this.fb.group({
      'id': new FormControl(0), //ok
      'descripcion': new FormControl('', [Validators.required, Validators.maxLength(50)]), //ok
      'comercializacion': new FormControl(0, [Validators.min(1)]), //ok
      'aliado': new FormControl(0, [Validators.min(1)]), //ok
      'descripcionAliado': new FormControl(''), //ok
      'canal': new FormControl(0, [Validators.min(1)]), //ok
      'descripcionCanal': new FormControl(''), //ok
      'tipoAfiliacion': new FormControl(0, [Validators.min(1)]), //ok
      'habilitado': new FormControl(true), //ok
      'precio': new FormControl(0),
      'compra': new FormControl('', [Validators.maxLength(6)]), //ok
      'montobase': new FormControl(0),
      'ivaimpuesto': new FormControl(0),
      'ivabase': new FormControl(0),
      'equivalencia': new FormControl('', [Validators.maxLength(6)]), //ok
      'imagen': new FormControl(''), //ok
      'idReasignar': new FormControl(0), //ok
      'mesesReasignar': new FormControl(0), //ok
      'conservacion': new FormControl(false), //ok
      'sucursal_defecto': new FormControl(''), //ok
      'registrarBeneficiarios': new FormControl(false), //ok
      'beneficiariosrequeridos': new FormControl(false), //ok
      'terminoscondiciones': new FormControl(''), //ok
      'fechaInicioVigencia': new FormControl(new Date()), //ok
      'fechaFinVigencia': new FormControl(new Date()), //ok
      'notificacionSMS': new FormControl(false), //ok
      'notificacionEmail': new FormControl(false), //ok
      'registrarEstado': new FormControl(false), //ok
      'manejaFechaNacimiento': new FormControl(false), //ok
      'manejaDomicilio': new FormControl(false), //ok
      'manejaObservaciones': new FormControl(false), //ok
      'firmaElectronica': new FormControl(false), //ok
      'operacionesReembolso': new FormControl(false), //ok
      'programaSara': new FormControl(0), //ok
      'edadMinima': new FormControl(0), //ok
      'edadMaxima': new FormControl(0), //ok
      'tomador': new FormControl(false), //ok
      'duplicarTitular': new FormControl(false), //ok
      'urlNotificacion': new FormControl('', [Validators.maxLength(500)]), //ok
      'lineaNacional': new FormControl('', [Validators.maxLength(200)]), //ok
      'nroFijo': new FormControl('', [Validators.maxLength(200)]), //ok
      'edadMinimaTomador': new FormControl(0), //ok
      'edadMaximaTomador': new FormControl(0), //ok
      'estadoDependienteFecha': new FormControl(false), //ok
      'permiteEditar': new FormControl(false), //ok
      'programacionPrecios': new FormControl(false), //ok
      'rutaRegistroFotografico': new FormControl(''), //ok
      'cantidadAnnosModelo': new FormControl(0), //ok
      'rutaControlOperaciones': new FormControl(''), //ok
      'rutaRegistroExpedientes': new FormControl(''), //ok
    });

    this.formConsulta = this.fb.group({
      id: [0],
      filtro: ['']
    });

    this.IniciarFormularioPlazos();
    this.IniciarFormularioEdades();
    this.IniciarFormularioCodigosActivacion();
    this.IniciarFormularioFirmaElectronica();
    this.IniciarFormularioExpedientes();
    this.IniciarFormularioEstadosDias();
    this.IniciarFormularioCampos();
    this.IniciarFormularioCamposBeneficiarios();
  }
  EstablecerDatosAdicionalesRequeridos() {
    this.form.get('mesesReasignar').setValidators([]);
    this.form.get('mesesReasignar').updateValueAndValidity();
    this.form.get('precio').setValidators([]);
    this.form.get('precio').updateValueAndValidity();
    this.form.get('ivaimpuesto').setValidators([]);
    this.form.get('ivaimpuesto').updateValueAndValidity();
    this.form.get('montobase').setValidators([]);
    this.form.get('montobase').updateValueAndValidity();

    if (this.utilitariosService.VerificarContieneDatosNumerico(this.form.get('idReasignar').value)) {
      let validatorsAdicionar = [];
      validatorsAdicionar.push(Validators.min(1));
      this.form.get('mesesReasignar').setValidators(validatorsAdicionar);
      this.form.get('mesesReasignar').updateValueAndValidity();
    }

    if (this.HabilitarIngresoPrecioManual()) {
      let validatorsAdicionar = [];
      validatorsAdicionar.push(Validators.min(1));
      this.form.get('precio').setValidators(validatorsAdicionar);
      this.form.get('precio').updateValueAndValidity();
      this.form.get('ivaimpuesto').setValidators(validatorsAdicionar);
      this.form.get('ivaimpuesto').updateValueAndValidity();
      this.form.get('montobase').setValidators(validatorsAdicionar);
      this.form.get('montobase').updateValueAndValidity();
    }
  }
  CancelarRegistro() {
    this.menuService.CambiarComponenteActivo('MaestrosProductosComponent');
  }
  Guardar(codigoAccionActualizacion: string = '') {
    if (this.form.valid) {
      this.codigoAccion = 'guardar';
      this.codigoAccionActualizacion = codigoAccionActualizacion;
      this._appconfirmacion.MostrarMensajeConfirmacion();
    } else {
      if (codigoAccionActualizacion !== '') {
        this.utilitariosService.MensajeToast('Es necesario que la pestaña de información tenga los datos validos para utilizar esta opción.');
      }
      this.utilitariosService.MostrarErroresFormulario(this.form);
    }
  }
  ConfirmoUsuario(confirmo: boolean) {
    if (confirmo) {
      if (this.codigoAccion === 'guardar') {
        this.ActualizarRegistro();
      } else if (this.codigoAccion === 'eliminarPlazo') {
        this.EliminarRegistroPlazos();
      } else if (this.codigoAccion === 'eliminarEdad') {
        this.EliminarRegistroEdades();
      } else if (this.codigoAccion === 'eliminarCodigosActivacion') {
        this.EliminarRegistroCodigosActivacion();
      } else if (this.codigoAccion === 'eliminarFirmaElectronica') {
        this.EliminarRegistroFirmaElectronica();
      } else if (this.codigoAccion === 'eliminarFirmaElectronicaCampos') {
        this.EliminarRegistroFirmaElectronicaCampos();
      } else if (this.codigoAccion === 'eliminarFirmaElectronicaCamposUbicacion') {
        this.EliminarRegistroFirmaElectronicaCamposUbicacion();
      } else if (this.codigoAccion === 'eliminarExpediente') {
        this.EliminarRegistroExpedientes();
      } else if (this.codigoAccion === 'eliminarEstadosDias') {
        this.EliminarRegistroEstadosDias();
      } else if (this.codigoAccion === 'eliminarCampos') {
        this.EliminarRegistroCampos();
      } else if (this.codigoAccion === 'eliminarCamposBeneficiarios') {
        this.EliminarRegistroCamposBeneficiarios();
      } else if (this.codigoAccion === 'eliminarNotificaciones') {
        this.EliminarRegistroNotificaciones();
      }
    }
  }
  Cambio_Aliado() {
    this.ConsultarListas();
    this.CargarListaCanales();
  }
  Cambio_IdReasignar() {
    this.EstablecerDatosAdicionalesRequeridos();
  }
  Cambio_TipoVigencia() {
    if (this.HabilitarIngresoPrecioManual()) {
      if (!this.utilitariosService.VerificarContieneDatosNumerico(this.form.get('ivaimpuesto').value)) {
        if (this.utilitariosService.VerificarContieneDatosLista(this.listasImpuestos)) {
          this.form.get('ivaimpuesto').setValue(this.listasImpuestos[0].id);
        }
      }
    }

    this.EstablecerDatosAdicionalesRequeridos();
  }
  Cambio_FirmaElectronica() {
    this.EstablecerDatosAdicionalesRequeridos();
  }
  CargarListaCanales() {
    this.listasCanalesSeleccion = this.listasCanales.filter(x => x.dependienciaId === this.form.get('aliado').value);
  }
  HabilitarMesesReasignar(): boolean {
    return this.utilitariosService.VerificarContieneDatosNumerico(this.form.get('idReasignar').value);
  }
  HabilitarBeneficiariosRequerido(): boolean {
    return this.form.get('registrarBeneficiarios').value;
  }
  HabilitarIngresoPrecioManual(): boolean {
    if (this.utilitariosService.VerificarContieneDatosLista(this.listasTipoVinculacion)) {
      if (this.listasTipoVinculacion.filter(x => x.id === this.form.get('tipoAfiliacion').value).length > 0) {
        return this.listasTipoVinculacion.filter(x => x.id === this.form.get('tipoAfiliacion').value)[0].codigo === 'M';
      }
    }
    return false;
  }
  HabilitarFirmaElectronica(): boolean {
    return this.form.get('firmaElectronica').value;
  }
  HabilitarTipoFirmaElectronicaAuco(): boolean {
    return this.formFirmaElectronica.get('tipoFirmaElectronica').value === 'AUCO';
  }
  HabilitarIngresoVigencia(): boolean {
    if (this.utilitariosService.VerificarContieneDatosLista(this.listasTipoVinculacion)) {
      if (this.listasTipoVinculacion.filter(x => x.id === this.form.get('tipoAfiliacion').value).length > 0) {
        return this.listasTipoVinculacion.filter(x => x.id === this.form.get('tipoAfiliacion').value)[0].codigo === 'V';
      }
    }
    
    return false;
  }
  HabilitarIngresoEdades(): boolean {
    if (this.utilitariosService.VerificarContieneDatosLista(this.listasTipoVinculacion)) {
      if (this.listasTipoVinculacion.filter(x => x.id === this.form.get('tipoAfiliacion').value).length > 0) {
        return this.listasTipoVinculacion.filter(x => x.id === this.form.get('tipoAfiliacion').value)[0].codigo === 'E';
      }
    }
    
    return false;
  }
  HabilitarIngresoCodigos(): boolean {
    if (this.utilitariosService.VerificarContieneDatosLista(this.listasComercializacion)) {
      if (this.listasComercializacion.filter(x => x.id === this.form.get('comercializacion').value).length > 0) {
        return this.listasComercializacion.filter(x => x.id === this.form.get('comercializacion').value)[0].codigo === 'WEB';
      }
    }
    
    return false;
  }
  HabilitarExpedientes(): boolean {
    if (this.utilitariosService.VerificarContieneDatosNumerico(this.form.get('programaSara')?.value)) {
      return true;
    }
    
    return false;
  }
  Calcular_Valor() {
    if (this.cambiarValores) {
      this.cambiarValores = false
      let valorIva: number = 0;
      let valorbase: number = 0;
      let ivabase: number = 0;
      let precio: number = 0;
      if (this.listasImpuestos.filter(x => x.id === this.form.get('ivaimpuesto').value).length > 0) {
        valorIva = this.listasImpuestos.filter(x => x.id === this.form.get('ivaimpuesto').value)[0].condicionFloat1;
      }
  
      valorbase = this.form.get('montobase').value;
      ivabase = Math.round(valorbase * valorIva / 100);
      precio = valorbase + ivabase;
  
      this.form.get('ivabase').setValue(ivabase);
      this.form.get('precio').setValue(precio);
      this.cambiarValores = true;
    }
  }
  Cambio_Precio() {
    if (this.cambiarValores) {
      this.cambiarValores = false;
      let valorIva: number = 0;
      let valorbase: number = 0;
      let ivabase: number = 0;
      let precio: number = 0;
      if (this.listasImpuestos.filter(x => x.id === this.form.get('ivaimpuesto').value).length > 0) {
        valorIva = this.listasImpuestos.filter(x => x.id === this.form.get('ivaimpuesto').value)[0].condicionFloat1;
        valorIva = valorIva / 100;
        valorIva = valorIva + 1;
      }
  
      precio = this.form.get('precio').value;
      valorbase = Math.round(precio / valorIva);
      ivabase = precio - valorbase;
  
      this.form.get('ivabase').setValue(ivabase);
      this.form.get('montobase').setValue(valorbase);
      this.cambiarValores = true;
    }
  }
  ActualizarRegistro() {
    if (!this.mostrarCargando) {
      this.mostrarCargando = true;
    
      let parametrosActualizacion: Maestro_Productos_Actualizacion = new Maestro_Productos_Actualizacion();
      parametrosActualizacion.principal = new Maestro_Productos();

      let codigoComercializacion: string = '';
      if (this.listasComercializacion.filter(x => x.id === this.form.get('comercializacion').value).length > 0) {
        codigoComercializacion = this.listasComercializacion.filter(x => x.id === this.form.get('comercializacion').value)[0].codigo;
      }

      parametrosActualizacion.codigoComercializacion = codigoComercializacion;
      parametrosActualizacion.principal.id = this.form.get('id').value;
      parametrosActualizacion.principal.descripcion = this.form.get('descripcion').value;
      parametrosActualizacion.principal.comercializacion = this.form.get('comercializacion').value;
      parametrosActualizacion.principal.aliado = this.form.get('aliado').value;
      parametrosActualizacion.principal.descripcionAliado = this.form.get('descripcionAliado').value;
      parametrosActualizacion.principal.canal = this.form.get('canal').value;
      parametrosActualizacion.principal.descripcionCanal = this.form.get('descripcionCanal').value;
      parametrosActualizacion.principal.tipoAfiliacion = this.form.get('tipoAfiliacion').value;
      parametrosActualizacion.principal.habilitado = this.form.get('habilitado').value;
      parametrosActualizacion.principal.precio = this.form.get('precio').value;
      parametrosActualizacion.principal.compra = this.form.get('compra').value;
      parametrosActualizacion.principal.montobase = this.form.get('montobase').value;
      parametrosActualizacion.principal.ivaimpuesto = this.form.get('ivaimpuesto').value;
      parametrosActualizacion.principal.ivabase = this.form.get('ivabase').value;
      parametrosActualizacion.principal.equivalencia = this.form.get('equivalencia').value;
      parametrosActualizacion.principal.imagen = this.form.get('imagen').value;
      parametrosActualizacion.principal.idReasignar = this.form.get('idReasignar').value;
      parametrosActualizacion.principal.mesesReasignar = this.form.get('mesesReasignar').value;
      parametrosActualizacion.principal.conservacion = this.form.get('conservacion').value;
      parametrosActualizacion.principal.sucursal_defecto = this.listasCanalesSeleccion.filter(x => x.id === this.form.get('canal').value)[0].descripcion;
      parametrosActualizacion.principal.registrarBeneficiarios = this.form.get('registrarBeneficiarios').value;
      parametrosActualizacion.principal.beneficiariosrequeridos = this.form.get('beneficiariosrequeridos').value;
      parametrosActualizacion.principal.terminoscondiciones = this.form.get('terminoscondiciones').value;
      parametrosActualizacion.principal.fechaInicioVigencia = this.form.get('fechaInicioVigencia').value;
      parametrosActualizacion.principal.fechaFinVigencia = this.form.get('fechaFinVigencia').value;
      parametrosActualizacion.principal.notificacionSMS = this.form.get('notificacionSMS').value;
      parametrosActualizacion.principal.notificacionEmail = this.form.get('notificacionEmail').value;
      parametrosActualizacion.principal.registrarEstado = this.form.get('registrarEstado').value;
      parametrosActualizacion.principal.manejaFechaNacimiento = this.form.get('manejaFechaNacimiento').value;
      parametrosActualizacion.principal.manejaDomicilio = this.form.get('manejaDomicilio').value;
      parametrosActualizacion.principal.manejaObservaciones = this.form.get('manejaObservaciones').value;
      parametrosActualizacion.principal.firmaElectronica = this.form.get('firmaElectronica').value;
      parametrosActualizacion.principal.operacionesReembolso = this.form.get('operacionesReembolso').value;
      parametrosActualizacion.principal.programaSara = this.form.get('programaSara').value;
      parametrosActualizacion.principal.edadMinima = this.form.get('edadMinima').value;
      parametrosActualizacion.principal.edadMaxima = this.form.get('edadMaxima').value;
      parametrosActualizacion.principal.tomador = this.form.get('tomador').value;
      parametrosActualizacion.principal.duplicarTitular = this.form.get('duplicarTitular').value;
      parametrosActualizacion.principal.urlNotificacion = this.form.get('urlNotificacion').value;
      parametrosActualizacion.principal.lineaNacional = this.form.get('lineaNacional').value;
      parametrosActualizacion.principal.nroFijo = this.form.get('nroFijo').value;
      parametrosActualizacion.principal.edadMinimaTomador = this.form.get('edadMinimaTomador').value;
      parametrosActualizacion.principal.edadMaximaTomador = this.form.get('edadMaximaTomador').value;
      parametrosActualizacion.principal.estadoDependienteFecha = this.form.get('estadoDependienteFecha').value;
      parametrosActualizacion.principal.permiteEditar = this.form.get('permiteEditar').value;
      parametrosActualizacion.principal.programacionPrecios = this.form.get('programacionPrecios').value;
      parametrosActualizacion.principal.rutaRegistroFotografico = this.form.get('rutaRegistroFotografico').value;
      parametrosActualizacion.principal.cantidadAnnosModelo = this.form.get('cantidadAnnosModelo').value;
      parametrosActualizacion.principal.rutaControlOperaciones = this.form.get('rutaControlOperaciones').value;
      parametrosActualizacion.principal.rutaRegistroExpedientes = this.form.get('rutaRegistroExpedientes').value;

      parametrosActualizacion.listaPlazos = this.listaDatosPlazos;
      parametrosActualizacion.listaPlazosEliminar = this.listaDatosPlazosEliminar;
      parametrosActualizacion.listaEdades = this.listaDatosEdades;
      parametrosActualizacion.listaEdadesEliminar = this.listaDatosEdadesEliminar;
      parametrosActualizacion.listaFirmaElectronica = this.listaDatosFirmaElectronica;
      parametrosActualizacion.listaFirmaElectronicaEliminar = this.listaDatosFirmaElectronicaEliminar;
      parametrosActualizacion.listaCodigosActivacion = this.listaDatosCodigosActivacion;
      parametrosActualizacion.listaCodigosActivacionEliminar = this.listaDatosCodigosActivacionEliminar;
      parametrosActualizacion.listaExpedientes = this.listaDatosExpedientes;
      parametrosActualizacion.listaExpedientesEliminar = this.listaDatosExpedientesEliminar;
      parametrosActualizacion.listaEstadosDias = this.listaDatosEstadosDias;
      parametrosActualizacion.listaEstadosDiasEliminar = this.listaDatosEstadosDiasEliminar;
      parametrosActualizacion.listaCampos = this.listaDatosCampos;
      parametrosActualizacion.listaCamposEliminar = this.listaDatosCamposEliminar;
      parametrosActualizacion.listaCamposBeneficiarios = this.listaDatosCamposBeneficiarios;
      parametrosActualizacion.listaCamposBeneficiariosEliminar = this.listaDatosCamposBeneficiariosEliminar;
      parametrosActualizacion.listaNotificaciones = this.listaDatosNotificaciones;
      parametrosActualizacion.listaNotificacionesEliminar = this.listaDatosNotificacionesEliminar;
  
      this.datosServices.Actualizar(parametrosActualizacion)
              .subscribe((resp: RespuestaGenerica) =>{
                this.mostrarCargando = false;
                if (resp.procesoExitoso == false) {
                  this.utilitariosService.MensajeToast(resp.mensaje);
                } else {
                  this.form.get('id')?.setValue(resp.id);

                  if (this.codigoAccionActualizacion === 'CARGACODIGOS') {
                    this.AbrirCargarArchivo();
                  } else {
                    this.menuService.CambiarComponenteActivo('MaestrosProductosComponent');
                  }
                }
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
    }
  }
  ConsultarListas() {
    this.mostrarCargando = true;
    let parametrosConsulta = this.fb.group({
      id: [0],
      filtro: ['']
    });

    parametrosConsulta.get('id').setValue(+this.form.get('aliado').value);

    this.datosServices.ConsultarListas(parametrosConsulta.value)
              .subscribe((resp: Listas[]) =>{
                this.mostrarCargando = false;
                this.listasCompletas = resp;
                
                this.listasComercializacion = this.listasCompletas.filter(x => x.lista === 'COMERCIALIZACION');
                this.listasTipoVinculacion = this.listasCompletas.filter(x => x.lista === 'TIPOAFILIACION');
                this.listasImpuestos = this.listasCompletas.filter(x => x.lista === 'IMPUESTO_IVA');
                this.listasProductos = this.listasCompletas.filter(x => x.lista === 'MAESTRO_PRODUCTOS' && x.id !== this.form.get('id').value);
                this.listasFirmaElectronicaConfiguracion = this.listasCompletas.filter(x => x.lista === 'FIRMAELECTRONICA_CONFIGURACION');
                this.listasProgramasExpedientes = this.listasCompletas.filter(x => x.lista === 'EXPEDIENTES_PROGRAMAS');
                this.listasServiciosExpedientes = this.listasCompletas.filter(x => x.lista === 'EXPEDIENTES_SERVICIOS');
                this.listasSubServiciosExpedientes = this.listasCompletas.filter(x => x.lista === 'EXPEDIENTES_SUBSERVICIOS');
                this.listasEstadosConfiguracion = this.listasCompletas.filter(x => x.lista === 'ESTADOS_CONFIGURACION');
                this.listasTipoCampos = this.listasCompletas.filter(x => x.lista === 'TIPOCAMPO').sort((n1, n2) => {
                  if (n1.descripcion > n2.descripcion) {
                      return 1;
                  }
              
                  if (n1.descripcion < n2.descripcion) {
                      return -1;
                  }
              
                  return 0;
                });
                this.listasTipoCodigoOPT = this.listasCompletas.filter(x => x.lista === 'TIPOCODIGOOPT');
                this.listasFirmaElectronicaFuente = this.listasCompletas.filter(x => x.lista === 'FIRMAELECTRONICA_FUENTE');
                this.listaTopicosCamposAdicionales = this.listasCompletas.filter(x => x.lista === 'TIPOLISTATOPICO');
                this.listaTipoDescargaFirmaElectronica = this.listasCompletas.filter(x => x.lista === 'TIPODESCARGAR_FIRMAELECTRONICA');
                
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }
  ConsultarAliados() {
    this.mostrarCargando = true;

    this.datosServices.ConsultarAliados()
              .subscribe((resp: Listas[]) =>{
                this.mostrarCargando = false;
                this.listasAliados = resp.filter(x => x.lista === 'ALIADOS');
                this.listasCanales = resp.filter(x => x.lista === 'CANALES');
                this.CargarListaCanales();
              },
              (error: Error) => {
                this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                this.mostrarCargando = false;
                this.cd.detectChanges();
              },
              () => this.cd.detectChanges());
  }

  ConsultarRegistrosPlazos() {
    if (this.utilitariosService.VerificarContieneDatosNumerico(this.parametrosPrincipal.id)) {
      this.mostrarCargando = true;
  
      let parametrosConsulta = this.fb.group({
        id: [0],
        aliado: [0]
      });
  
      parametrosConsulta.get('id').setValue(this.parametrosPrincipal.id);
      parametrosConsulta.get('aliado').setValue(this.form.get('aliado').value);
      this.datosServices.ConsultarPlazos(parametrosConsulta.value)
                .subscribe((resp: Maestro_ProductosPlazos[]) =>{
                  this.mostrarCargando = false;
                  this.listaDatosPlazos = resp;
                  this.recargarListaPlazos();
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
    }
  }
  ConsultarRegistrosEdades() {
    if (this.utilitariosService.VerificarContieneDatosNumerico(this.parametrosPrincipal.id)) {
      this.mostrarCargando = true;
  
      let parametrosConsulta = this.fb.group({
        id: [0],
        aliado: [0]
      });
  
      parametrosConsulta.get('id').setValue(this.parametrosPrincipal.id);
      parametrosConsulta.get('aliado').setValue(this.form.get('aliado').value);
      this.datosServices.ConsultarEdades(parametrosConsulta.value)
                .subscribe((resp: Maestro_ProductosEdades[]) =>{
                  this.mostrarCargando = false;
                  this.listaDatosEdades = resp;
                  this.recargarListaEdades();
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
    }
  }
  ConsultarRegistrosFirmaElectronica() {
    if (this.utilitariosService.VerificarContieneDatosNumerico(this.parametrosPrincipal.id)) {
      this.mostrarCargando = true;
  
      let parametrosConsulta = this.fb.group({
        id: [0],
        aliado: [0]
      });
  
      parametrosConsulta.get('id').setValue(this.parametrosPrincipal.id);
      parametrosConsulta.get('aliado').setValue(this.form.get('aliado').value);
      this.datosServices.ConsultarFirmaElectronica(parametrosConsulta.value)
                .subscribe((resp: Maestro_ProductosFirmaElectronica[]) =>{
                  this.mostrarCargando = false;
                  this.listaDatosFirmaElectronica = resp;
                  this.recargarListaFirmaElectronica();
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
    }
  }
  ConsultarRegistrosCodigosActivacion() {
    if (this.utilitariosService.VerificarContieneDatosNumerico(this.parametrosPrincipal.id)) {
      this.mostrarCargando = true;
  
      let parametrosConsulta = this.fb.group({
        id: [0],
        aliado: [0]
      });
  
      parametrosConsulta.get('id').setValue(this.parametrosPrincipal.id);
      parametrosConsulta.get('aliado').setValue(this.form.get('aliado').value);
      this.datosServices.ConsultarCodigosActivacion(parametrosConsulta.value)
                .subscribe((resp: Maestro_ProductosCodigosActivacion[]) =>{
                  this.mostrarCargando = false;
                  this.listaDatosCodigosActivacion = resp;
                  this.recargarListaCodigosActivacion();
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
    }
  }
  ConsultarRegistrosExpedientes() {
    if (this.utilitariosService.VerificarContieneDatosNumerico(this.parametrosPrincipal.id)) {
      this.mostrarCargando = true;
  
      let parametrosConsulta = this.fb.group({
        id: [0],
        aliado: [0]
      });
  
      parametrosConsulta.get('id').setValue(this.parametrosPrincipal.id);
      parametrosConsulta.get('aliado').setValue(this.form.get('aliado').value);
      this.datosServices.ConsultarExpedientes(parametrosConsulta.value)
                .subscribe((resp: Maestro_ProductosExpedientes[]) =>{
                  this.mostrarCargando = false;
                  this.listaDatosExpedientes = resp;
                  this.recargarListaExpedientes();
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
    }
  }
  ConsultarRegistrosEstadosDias() {
    if (this.utilitariosService.VerificarContieneDatosNumerico(this.parametrosPrincipal.id)) {
      this.mostrarCargando = true;
  
      let parametrosConsulta = this.fb.group({
        id: [0],
        aliado: [0]
      });
  
      parametrosConsulta.get('id').setValue(this.parametrosPrincipal.id);
      parametrosConsulta.get('aliado').setValue(this.form.get('aliado').value);
      this.datosServices.ConsultarEstadosDias(parametrosConsulta.value)
                .subscribe((resp: Maestro_ProductosEstadosDias[]) =>{
                  this.mostrarCargando = false;
                  this.listaDatosEstadosDias = resp;
                  this.recargarListaEstadosDias();
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
    }
  }
  ConsultarRegistrosCampos() {
    if (this.utilitariosService.VerificarContieneDatosNumerico(this.parametrosPrincipal.id)) {
      this.mostrarCargando = true;
  
      let parametrosConsulta = this.fb.group({
        id: [0],
        aliado: [0]
      });
  
      parametrosConsulta.get('id').setValue(this.parametrosPrincipal.id);
      parametrosConsulta.get('aliado').setValue(this.form.get('aliado').value);
      this.datosServices.ConsultarCampos(parametrosConsulta.value)
                .subscribe((resp: Maestro_ProductosCampos[]) =>{
                  this.mostrarCargando = false;
                  this.listaDatosCampos = resp;
                  this.recargarListaCampos();
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
    }
  }
  ConsultarRegistrosCamposBeneficiarios() {
    if (this.utilitariosService.VerificarContieneDatosNumerico(this.parametrosPrincipal.id)) {
      this.mostrarCargando = true;
  
      let parametrosConsulta = this.fb.group({
        id: [0],
        aliado: [0]
      });
  
      parametrosConsulta.get('id').setValue(this.parametrosPrincipal.id);
      parametrosConsulta.get('aliado').setValue(this.form.get('aliado').value);
      this.datosServices.ConsultarCamposBeneficiarios(parametrosConsulta.value)
                .subscribe((resp: Maestro_ProductosCamposBeneficiarios[]) =>{
                  this.mostrarCargando = false;
                  this.listaDatosCamposBeneficiarios = resp;
                  this.recargarListaCamposBeneficiarios();
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
    }
  }
  ConsultarRegistrosNotificaciones() {
    if (this.utilitariosService.VerificarContieneDatosNumerico(this.parametrosPrincipal.id)) {
      this.mostrarCargando = true;
      
      let parametrosConsulta = this.fb.group({
        id: [0],
        aliado: [0]
      });
  
      parametrosConsulta.get('id').setValue(this.parametrosPrincipal.id);
      parametrosConsulta.get('aliado').setValue(this.form.get('aliado').value);
      this.datosServices.ConsultarNotificaciones(parametrosConsulta.value)
                .subscribe((resp: Maestro_ProductosNotificaciones[]) =>{
                  this.mostrarCargando = false;
                  for (let index = 0; index < resp.length; index++) {
                    if (this.utilitariosService.VerificarContieneDatosTexto(resp[index].emailMensaje)) {
                      resp[index].emailMensajeMostrar = 'Mensaje html...';
                    } else {
                      resp[index].emailMensajeMostrar = '';
                    }
                  }
                  this.listaDatosNotificaciones = resp;
                  this.recargarListaNotificaciones();
                },
                (error: Error) => {
                  this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
                  this.mostrarCargando = false;
                  this.cd.detectChanges();
                },
                () => this.cd.detectChanges());
    }
  }
  tabSeleccionado(item: any) {
    console.log('tabSeleccionado', item);
    this.tabItemSeleccionadoAnterior = this.tabItemSeleccionado;
    this.tabItemSeleccionado = item.tab.textLabel;
    
    if (this.tabItemSeleccionado === 'tabPrecios') {
      this.recargarListaPlazos();
    } else if (this.tabItemSeleccionado === 'tabEdades') {
      this.recargarListaEdades();
    } else if (this.tabItemSeleccionado === 'tabCargaCodigos') {
      this.recargarListaCodigosActivacion();
    } else if (this.tabItemSeleccionado === 'tabFirmaDocumentos') {
      this.recargarListaFirmaElectronica();
    } else if (this.tabItemSeleccionado === 'tabExpedientes') {
      this.recargarListaExpedientes();
    } else if (this.tabItemSeleccionado === 'tabEstadosDias') {
      this.recargarListaEstadosDias();
    } else if (this.tabItemSeleccionado === 'tabCampos') {
      this.recargarListaCampos();
    } else if (this.tabItemSeleccionado === 'tabCamposBeneficiarios') {
      this.recargarListaCamposBeneficiarios();
    } else if (this.tabItemSeleccionado === 'tabNotificaciones') {
      this.recargarListaNotificaciones();
    }
  }
  ObtenerListaSubServicio() {
    this.listasSubServiciosExpedientesFiltrada = this.listasSubServiciosExpedientes.filter(x => x.dependienciaId === this.formExpedientes.get('idServicio')?.value);
  }
  HabilitarRegistrarFechaNacimiento(): boolean {
    return this.form.get('manejaFechaNacimiento').value;
  }
  HabilitarDatosTomador(): boolean {
    return this.form.get('tomador').value;
  }
  HabilitarRegistrarEstado(): boolean {
    return this.form.get('registrarEstado').value;
  }
  HabilitarRegistrarEstadosDias(): boolean {
    return this.form.get('estadoDependienteFecha').value;
  }
  //plazos
  IniciarFormularioPlazos() {
    this.formPlazos = this.fb.group({
      'id': new FormControl(0),
      'plazoMeses': new FormControl(0, [Validators.min(1)]),
      'descripcion': new FormControl('', [Validators.required, Validators.maxLength(100)]),
      'precio': new FormControl(0),
      'montobase': new FormControl(0),
      'ivaimpuesto': new FormControl(0),
      'ivabase': new FormControl(0),
      'total': new FormControl(0),
      'habilitado': new FormControl(true),
      'precioconbeneficiario': new FormControl(0),
      'montobaseconbeneficiario': new FormControl(0),
      'ivaimpuestoconbeneficiario': new FormControl(0),
      'ivabaseconbeneficiario': new FormControl(0),
      'totalconbeneficiario': new FormControl(0),
      'mesesCobro': new FormControl(0),
      'sinMesesCobro': new FormControl(false),
    });

    this.EstablecerDatosPlazosRequeridos();
  }
  EstablecerDatosPlazosRequeridos() {
    this.formPlazos.get('mesesCobro').setValidators([]);
    this.formPlazos.get('mesesCobro').updateValueAndValidity();

    if (!this.formPlazos.get('sinMesesCobro').value) {
      let validatorsAdicionar = [];
      validatorsAdicionar.push(Validators.min(1));
      this.formPlazos.get('mesesCobro').setValidators(validatorsAdicionar);
      this.formPlazos.get('mesesCobro').updateValueAndValidity();
    }
  }
  recargarListaPlazos() {
    this.dataSourcePlazos = new MatTableDataSource(this.listaDatosPlazos);
    setTimeout(() => {
      this.dataSourcePlazos.paginator = this.paginatorplazos;
      this.dataSourcePlazos.sort = this.sortplazos;
    });
  }
  NuevoPlazos() {
    this.editarRegistroPlazos = true;
    this.IniciarFormularioPlazos();
    this.formPlazos.get('id').setValue((this.listaDatosPlazos.length + 1) * -1);
  }
  EditarPlazos(plazosEditar: Maestro_ProductosPlazos) {
    this.editarRegistroPlazos = true;
    this.formPlazos.setValue(plazosEditar);
    this.EstablecerDatosPlazosRequeridos();
  }
  EliminarPlazos(plazosEditar: Maestro_ProductosPlazos) {
    this.detalleSeleccionadoPlazos = plazosEditar.id;
    this.codigoAccion = 'eliminarPlazo';
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  GuardarPlazos() {
    if (this.formPlazos.valid) {
      this.editarRegistroPlazos = false;
      if (this.listaDatosPlazos.filter(x => x.id === this.formPlazos.get('id').value).length > 0) {
        let parametroActualizar = this.listaDatosPlazos.filter(x => x.id === this.formPlazos.get('id').value)[0];
        parametroActualizar.plazoMeses = this.formPlazos.get('plazoMeses').value;
        parametroActualizar.descripcion = this.formPlazos.get('descripcion').value;
        parametroActualizar.precio = this.formPlazos.get('precio').value;
        parametroActualizar.montobase = this.formPlazos.get('montobase').value;
        parametroActualizar.ivaimpuesto = this.formPlazos.get('ivaimpuesto').value;
        parametroActualizar.ivabase = this.formPlazos.get('ivabase').value;
        parametroActualizar.total = this.formPlazos.get('total').value;
        parametroActualizar.habilitado = this.formPlazos.get('habilitado').value;
        parametroActualizar.precioconbeneficiario = this.formPlazos.get('precioconbeneficiario').value;
        parametroActualizar.montobaseconbeneficiario = this.formPlazos.get('montobaseconbeneficiario').value;
        parametroActualizar.ivaimpuestoconbeneficiario = this.formPlazos.get('ivaimpuestoconbeneficiario').value;
        parametroActualizar.ivabaseconbeneficiario = this.formPlazos.get('ivabaseconbeneficiario').value;
        parametroActualizar.totalconbeneficiario = this.formPlazos.get('totalconbeneficiario').value;
        parametroActualizar.mesesCobro = this.formPlazos.get('mesesCobro').value;
        parametroActualizar.sinMesesCobro = this.formPlazos.get('sinMesesCobro').value;
        
      } else {
        this.listaDatosPlazos.push(this.formPlazos.value);
      }
      
      this.recargarListaPlazos();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.formPlazos);
    }
  }
  CancelarEditarPlazos() {
    this.editarRegistroPlazos = false;
  }
  EliminarRegistroPlazos() {
    if (this.detalleSeleccionadoPlazos > 0) {
      this.listaDatosPlazosEliminar.push(this.listaDatosPlazos.filter(x => x.id === this.detalleSeleccionadoPlazos)[0]);
    }
    let listaNueva: Maestro_ProductosPlazos[] = [];
    for (let index = 0; index < this.listaDatosPlazos.length; index++) {
      if (this.listaDatosPlazos[index].id !== this.detalleSeleccionadoPlazos) {
        listaNueva.push(this.listaDatosPlazos[index]);
      }
    }
    this.listaDatosPlazos = listaNueva;
    this.recargarListaPlazos();
  }
  Cambio_SinMesesCobro() {
    this.EstablecerDatosPlazosRequeridos();

    if (!this.formPlazos.get('sinMesesCobro').value) {
      this.formPlazos.get('mesesCobro').setValue(0);
      this.Calcular_ValorPlazo('CAMBIOMESES', 0);
      this.Calcular_ValorPlazoConBeneficiario('CAMBIOMESES', 0);
    }
  }
  Cambio_MesesPlazo(tipoCambio: string, controlCambiado: any) {
    this.Calcular_ValorPlazo(tipoCambio, +controlCambiado.target.value);
    this.Calcular_ValorPlazoConBeneficiario(tipoCambio, +controlCambiado.target.value);
  }
  Cambio_ValorPlazo(tipoCambio: string, controlCambiado: any) {
    this.Calcular_ValorPlazo(tipoCambio, +controlCambiado.target.value);
  }
  Calcular_ValorPlazo(tipoCambio: string, valorCambiado: number) {
    let valorModificado: number = 0;
    if (tipoCambio === 'PRECIOBASE') {
      valorModificado = +valorCambiado;
    }

    console.log('Calcular_ValorPlazoConBeneficiario', tipoCambio, valorModificado);

    let valorIva: number = 0;
    let valorbase: number = 0;
    let ivabase: number = 0;
    let precio: number = 0;
    let total: number = 0;
    if (this.listasImpuestos.filter(x => x.id === this.formPlazos.get('ivaimpuesto').value).length > 0) {
      valorIva = this.listasImpuestos.filter(x => x.id === this.formPlazos.get('ivaimpuesto').value)[0].condicionFloat1;
    }

    if (tipoCambio === 'PRECIOBASE') {
      valorbase = valorModificado;
      ivabase = Math.round(valorbase * (valorIva / 100));
      precio = Math.round(valorbase + ivabase);
    } else {
      valorbase = +this.formPlazos.get('montobase').value;
      ivabase = Math.round(valorbase * (valorIva / 100));
      precio = Math.round(valorbase + ivabase);
    }
    
    total = precio * this.formPlazos.get('mesesCobro').value;

    this.formPlazos.get('montobase').setValue(valorbase);
    this.formPlazos.get('ivabase').setValue(ivabase);
    this.formPlazos.get('precio').setValue(precio);    
    this.formPlazos.get('total').setValue(total);    
  }
  Cambio_ValorPlazoBeneficiario(tipoCambio: string, controlCambiado: any) {
    this.Calcular_ValorPlazoConBeneficiario(tipoCambio, +controlCambiado.target.value);
  }
  Calcular_ValorPlazoConBeneficiario(tipoCambio: string, valorCambiado: number) {
    let valorModificado: number = 0;
    if (tipoCambio === 'PRECIOBASE') {
      valorModificado = +valorCambiado;
    }

    console.log('Calcular_ValorPlazoConBeneficiario', tipoCambio, valorModificado);

    let valorIva: number = 0;
    let valorbase: number = 0;
    let ivabase: number = 0;
    let precio: number = 0;
    let total: number = 0;
    if (this.listasImpuestos.filter(x => x.id === this.formPlazos.get('ivaimpuestoconbeneficiario').value).length > 0) {
      valorIva = this.listasImpuestos.filter(x => x.id === this.formPlazos.get('ivaimpuestoconbeneficiario').value)[0].condicionFloat1;
    }

    if (tipoCambio === 'PRECIOBASE') {
      valorbase = valorModificado;
      ivabase = Math.round(valorbase * (valorIva / 100));
      precio = Math.round(valorbase + ivabase);
    } else {
      valorbase = +this.formPlazos.get('montobaseconbeneficiario').value;
      ivabase = Math.round(valorbase * (valorIva / 100));
      precio = Math.round(valorbase + ivabase);
    }
    
    total = precio * this.formPlazos.get('mesesCobro').value;

    this.formPlazos.get('montobaseconbeneficiario').setValue(valorbase);
    this.formPlazos.get('ivabaseconbeneficiario').setValue(ivabase);
    this.formPlazos.get('precioconbeneficiario').setValue(precio);    
    this.formPlazos.get('totalconbeneficiario').setValue(total);    
  }
  VerificarImpuesto
  //edades
  IniciarFormularioEdades() {
    this.formEdades = this.fb.group({
      'id': new FormControl(0),
      'descripcion': new FormControl('', [Validators.required, Validators.maxLength(100)]),
      'inicio': new FormControl(0, [Validators.min(1)]),
      'fin': new FormControl(0, [Validators.min(1)]),
      'precio': new FormControl(0, [Validators.min(1)]),
      'habilitado': new FormControl(false),
    });
  }
  recargarListaEdades() {
    this.dataSourceEdades = new MatTableDataSource(this.listaDatosEdades);
    setTimeout(() => {
      this.dataSourceEdades.paginator = this.paginatoredades;
      this.dataSourceEdades.sort = this.sortedades;
    });
  }
  NuevoEdades() {
    this.editarRegistroEdades = true;
    this.IniciarFormularioEdades();
    this.formEdades.get('id').setValue((this.listaDatosEdades.length + 1) * -1);
  }
  EditarEdades(edadesEditar: Maestro_ProductosEdades) {
    this.editarRegistroEdades = true;
    this.formEdades.setValue(edadesEditar);
  }
  EliminarEdades(edadesEditar: Maestro_ProductosEdades) {
    this.detalleSeleccionadoEdades = edadesEditar.id;
    this.codigoAccion = 'eliminarEdad';
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  GuardarEdades() {
    if (this.formEdades.valid) {
      this.editarRegistroEdades = false;
      if (this.listaDatosEdades.filter(x => x.id === this.formEdades.get('id').value).length > 0) {
        let parametroActualizar = this.listaDatosEdades.filter(x => x.id === this.formEdades.get('id').value)[0];
        parametroActualizar.descripcion = this.formEdades.get('descripcion').value;
        parametroActualizar.inicio = this.formEdades.get('inicio').value;
        parametroActualizar.fin = this.formEdades.get('fin').value;
        parametroActualizar.precio = this.formEdades.get('precio').value;
        parametroActualizar.habilitado = this.formEdades.get('habilitado').value;
      } else {
        this.listaDatosEdades.push(this.formEdades.value);
      }
      
      this.recargarListaEdades();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.formEdades);
    }
  }
  CancelarEditarEdades() {
    this.editarRegistroEdades = false;
  }
  EliminarRegistroEdades() {
    if (this.detalleSeleccionadoEdades > 0) {
      this.listaDatosEdadesEliminar.push(this.listaDatosEdades.filter(x => x.id === this.detalleSeleccionadoEdades)[0]);
    }
    let listaNueva: Maestro_ProductosEdades[] = [];
    for (let index = 0; index < this.listaDatosEdades.length; index++) {
      if (this.listaDatosEdades[index].id !== this.detalleSeleccionadoEdades) {
        listaNueva.push(this.listaDatosEdades[index]);
      }
    }
    this.listaDatosEdades = listaNueva;
    this.recargarListaEdades();
  }
  //firma electronica
  //**************************************/
  IniciarFormularioFirmaElectronica() {
    this.formFirmaElectronica = this.fb.group({
      'id': new FormControl(0),
      'idProducto': new FormControl(0),
      'descripcion': new FormControl('', [Validators.required, Validators.maxLength(100)]),
      'habilitado': new FormControl(true),
      'tipoFirmaElectronica': new FormControl('', [Validators.required]),
      'rutaArchivoFirmaElectronica': new FormControl(''),
      'nombreDocumentoFirmaElectronica': new FormControl('', [Validators.required, Validators.maxLength(100)]),
      'firmaElectronicaCamera': new FormControl(true),
      'firmaElectronicaOptCode': new FormControl(true),
      'firmaElectronicaFuente': new FormControl('', [Validators.required]),
      'listaCampos': new FormControl([]),
    });

    this.EstablecerFirmaElectronicaRequeridos();
  }
  EstablecerFirmaElectronicaRequeridos() {
    
  }
  recargarListaFirmaElectronica() {
    this.dataSourceFirmaElectronica = new MatTableDataSource(this.listaDatosFirmaElectronica);
    setTimeout(() => {
      this.dataSourceFirmaElectronica.paginator = this.paginatorfirmaeletronica;
      this.dataSourceFirmaElectronica.sort = this.sortfirmaelectronica;
    });
  }
  NuevoFirmaElectronica() {
    this.editarRegistroFirmaElectronica = true;
    this.IniciarFormularioFirmaElectronica();
    this.formFirmaElectronica.get('id').setValue((this.listaDatosFirmaElectronica.length + 1) * -1);
    this.formFirmaElectronica.get('habilitado').setValue(true);
  }
  EditarFirmaElectronica(firmaElectronicaEditar: Maestro_ProductosFirmaElectronica) {
    this.editarRegistroFirmaElectronica = true;
    this.formFirmaElectronica.setValue(firmaElectronicaEditar);
  }
  EliminarFirmaElectronica(firmaElectronicaEditar: Maestro_ProductosFirmaElectronica) {
    this.detalleSeleccionadoFirmaElectronica = firmaElectronicaEditar.id;
    this.codigoAccion = 'eliminarFirmaElectronica';
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  GuardarFirmaElectronica() {
    console.log('GuardarFirmaElectronica', this.formFirmaElectronica);
    if (this.formFirmaElectronica.valid) {
      this.editarRegistroFirmaElectronica = false;
      if (this.listaDatosFirmaElectronica.filter(x => x.id === this.formFirmaElectronica.get('id').value).length > 0) {
        let parametroActualizar = this.listaDatosFirmaElectronica.filter(x => x.id === this.formFirmaElectronica.get('id').value)[0];
        parametroActualizar.id = this.formFirmaElectronica.get('id').value;
        parametroActualizar.idProducto = this.formFirmaElectronica.get('idProducto').value;
        parametroActualizar.descripcion = this.formFirmaElectronica.get('descripcion').value;
        parametroActualizar.habilitado = this.formFirmaElectronica.get('habilitado').value;
        parametroActualizar.tipoFirmaElectronica = this.formFirmaElectronica.get('tipoFirmaElectronica').value;
        parametroActualizar.rutaArchivoFirmaElectronica = this.formFirmaElectronica.get('rutaArchivoFirmaElectronica').value;
        parametroActualizar.nombreDocumentoFirmaElectronica = this.formFirmaElectronica.get('nombreDocumentoFirmaElectronica').value;
        parametroActualizar.firmaElectronicaCamera = this.formFirmaElectronica.get('firmaElectronicaCamera').value;
        parametroActualizar.firmaElectronicaOptCode = this.formFirmaElectronica.get('firmaElectronicaOptCode').value;
        parametroActualizar.firmaElectronicaFuente = this.formFirmaElectronica.get('firmaElectronicaFuente').value;
        parametroActualizar.listaCampos = this.formFirmaElectronica.get('listaCampos').value;
      } else {
        this.listaDatosFirmaElectronica.push(this.formFirmaElectronica.value);
      }

      this.recargarListaFirmaElectronica();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.formFirmaElectronica);
    }
  }
  CancelarEditarFirmaElectronica() {
    this.editarRegistroFirmaElectronica = false;
  }
  EliminarRegistroFirmaElectronica() {
    if (this.detalleSeleccionadoFirmaElectronica > 0) {
      this.listaDatosFirmaElectronicaEliminar.push(this.listaDatosFirmaElectronica.filter(x => x.id === this.detalleSeleccionadoFirmaElectronica)[0]);
    }
    let listaNueva: Maestro_ProductosFirmaElectronica[] = [];
    for (let index = 0; index < this.listaDatosFirmaElectronica.length; index++) {
      if (this.listaDatosFirmaElectronica[index].id !== this.detalleSeleccionadoFirmaElectronica) {
        listaNueva.push(this.listaDatosFirmaElectronica[index]);
      }
    }
    this.listaDatosFirmaElectronica = listaNueva;
    this.recargarListaFirmaElectronica();
  }
  recargarListaFirmaElectronicaCampos() {
    this.dataSourceFirmaElectronica = new MatTableDataSource(this.listaDatosFirmaElectronica);
    setTimeout(() => {
      this.dataSourceFirmaElectronica.paginator = this.paginatorfirmaeletronica;
      this.dataSourceFirmaElectronica.sort = this.sortfirmaelectronica;
    });
  }
  //**************************************/
  //firma electronica campos
  //**************************************/
  IniciarFormularioFirmaElectronicaCampos() {
    this.formFirmaElectronicaCampos = this.fb.group({
      'id': new FormControl(0),
      'idProductoFirma': new FormControl(0),
      'tipoCampo': new FormControl('', [Validators.required]),
      'campo': new FormControl('', [Validators.required, Validators.maxLength(100)]),
      'descripcion': new FormControl(''),
      'valorCampo': new FormControl(''),
      'requerido': new FormControl(false),
      'habilitado': new FormControl(true),
      'listaDatos': new FormControl(''),
      'campoDependiente': new FormControl(''),
      'orden': new FormControl(0),
      'mostrar': new FormControl(false),
      'listaUbicaciones': new FormControl([]),
    });

    this.formFirmaElectronicaCamposCopiar = this.fb.group({
      'copiarConfiguracion': new FormControl(0, [Validators.min(1)]),
    });

    this.EstablecerFirmaElectronicaRequeridosCampos();
  }
  EstablecerFirmaElectronicaRequeridosCampos() {
    this.formFirmaElectronicaCampos.get('campo').setValidators([]);
    this.formFirmaElectronicaCampos.get('descripcion').setValidators([]);
    this.formFirmaElectronicaCampos.get('valorCampo').setValidators([]);
    this.formFirmaElectronicaCampos.get('listaDatos').setValidators([]);

    if (this.MostrarCodigoCampo()) {
      let validatorsAdicionar = [];
      validatorsAdicionar.push(Validators.required);
      validatorsAdicionar.push(Validators.maxLength(100));
      this.formFirmaElectronicaCampos.get('campo').setValidators(validatorsAdicionar);
      this.formFirmaElectronicaCampos.get('descripcion').setValidators(validatorsAdicionar);

      if (this.MostrarListaValores() || this.MostrarListaTopicos()) {
        let validatorsListaDatos = [];
        validatorsListaDatos.push(Validators.required);
        this.formFirmaElectronicaCampos.get('listaDatos').setValidators(validatorsListaDatos);
      }
    }

    if (this.MostrarValorCampo()) {
      let validatorsValorCampo = [];
      validatorsValorCampo.push(Validators.required);
      validatorsValorCampo.push(Validators.maxLength(500));
      this.formFirmaElectronicaCampos.get('valorCampo').setValidators(validatorsValorCampo);
    }

    this.formFirmaElectronicaCampos.get('campo').updateValueAndValidity();
    this.formFirmaElectronicaCampos.get('descripcion').updateValueAndValidity();
    this.formFirmaElectronicaCampos.get('valorCampo').updateValueAndValidity();
    this.formFirmaElectronicaCampos.get('listaDatos').updateValueAndValidity();
  }
  AbrirCamposFirmaElectronica(firmaElectronicaEditar: Maestro_ProductosFirmaElectronica) {
    console.log('AbrirCamposFirmaElectronica', firmaElectronicaEditar);
    this.editarRegistroFirmaElectronicaCampos = false;
    this.editarRegistroFirmaElectronicaCopiar = false;
    this.itemFirmaElectronicaSeleccionado = firmaElectronicaEditar;
    this.RecargarListaCamposFirmaElectronica(firmaElectronicaEditar.listaCampos);

    this.modal.open(this._ModalFirmaElectronicaCampos, {
      height: '650px',
      width: `${window.innerWidth - 100}px`
    });
  }
  NuevoFirmaElectronicaCampo() {
    this.editarRegistroFirmaElectronicaCampos = true;
    this.editarRegistroFirmaElectronicaCopiar = false;
    this.IniciarFormularioFirmaElectronicaCampos();
    this.formFirmaElectronicaCampos.get('id').setValue((this.itemFirmaElectronicaSeleccionado.listaCampos.length + 1) * -1);
    this.formFirmaElectronicaCampos.get('habilitado').setValue(true);
  }
  EditarFirmaElectronicaCampo(firmaElectronicaEditar: Maestro_ProductosFirmaElectronicaCampos) {
    this.editarRegistroFirmaElectronicaCampos = true;
    this.editarRegistroFirmaElectronicaCopiar = false;
    console.log('EditarFirmaElectronicaCampo', firmaElectronicaEditar);
    this.IniciarFormularioFirmaElectronicaCampos();
    this.formFirmaElectronicaCampos.setValue(firmaElectronicaEditar);
  }
  EliminarFirmaElectronicaCampo(firmaElectronicaEditar: Maestro_ProductosFirmaElectronicaCampos) {
    this.detalleSeleccionadoFirmaElectronicaCampos = firmaElectronicaEditar.id;
    this.codigoAccion = 'eliminarFirmaElectronicaCampos';
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  GuardarFirmaElectronicaCampo() {
    if (this.editarRegistroFirmaElectronicaCopiar) {
      if (this.formFirmaElectronicaCamposCopiar.valid) {
        let itemAgregar = this.listaDatosFirmaElectronica.filter(x => x.id === this.formFirmaElectronicaCamposCopiar.get('copiarConfiguracion')?.value)[0];
        let listaCamposEditar = this.listaDatosFirmaElectronica.filter(x => x.id === this.itemFirmaElectronicaSeleccionado.id)[0];
        listaCamposEditar.listaCampos = JSON.parse(JSON.stringify(itemAgregar.listaCampos));
        this.RecargarListaCamposFirmaElectronica(listaCamposEditar.listaCampos);
        this.editarRegistroFirmaElectronicaCampos = false;
        this.editarRegistroFirmaElectronicaCopiar = false;
      } else {
        this.utilitariosService.MostrarErroresFormulario(this.formFirmaElectronicaCamposCopiar);
      }
    } else {
      if (this.formFirmaElectronicaCampos.valid) {
        this.editarRegistroFirmaElectronicaCampos = false;
        this.editarRegistroFirmaElectronicaCopiar = false;
        let listaCamposEditar = this.listaDatosFirmaElectronica.filter(x => x.id === this.itemFirmaElectronicaSeleccionado.id)[0];
  
        console.log('GuardarFirmaElectronicaCampo-Antes', listaCamposEditar.listaCampos);
        if (listaCamposEditar.listaCampos.filter(x => x.id === this.formFirmaElectronicaCampos.get('id').value).length > 0) {
          let parametroActualizar = listaCamposEditar.listaCampos.filter(x => x.id === this.formFirmaElectronicaCampos.get('id').value)[0];
          parametroActualizar.id = this.formFirmaElectronicaCampos.get('id').value;
          parametroActualizar.idProductoFirma = this.formFirmaElectronicaCampos.get('idProductoFirma').value;
          parametroActualizar.tipoCampo = this.formFirmaElectronicaCampos.get('tipoCampo').value;
          parametroActualizar.campo = this.formFirmaElectronicaCampos.get('campo').value;
          parametroActualizar.descripcion = this.formFirmaElectronicaCampos.get('descripcion').value;
          parametroActualizar.valorCampo = this.formFirmaElectronicaCampos.get('valorCampo').value;
          parametroActualizar.requerido = this.formFirmaElectronicaCampos.get('requerido').value;
          parametroActualizar.habilitado = this.formFirmaElectronicaCampos.get('habilitado').value;
          parametroActualizar.listaDatos = this.formFirmaElectronicaCampos.get('listaDatos').value;
          parametroActualizar.campoDependiente = this.formFirmaElectronicaCampos.get('campoDependiente').value;
          parametroActualizar.orden = this.formFirmaElectronicaCampos.get('orden').value;
          parametroActualizar.mostrar = this.formFirmaElectronicaCampos.get('mostrar').value;
          parametroActualizar.listaUbicaciones = this.formFirmaElectronicaCampos.get('listaUbicaciones').value;
        } else {
          listaCamposEditar.listaCampos.push(this.formFirmaElectronicaCampos.value);
        }
  
        console.log('GuardarFirmaElectronicaCampo-Despues', listaCamposEditar.listaCampos);
  
        this.RecargarListaCamposFirmaElectronica(listaCamposEditar.listaCampos);
      } else {
        this.utilitariosService.MostrarErroresFormulario(this.formFirmaElectronicaCampos);
      }
    }
  }
  CancelarEditarFirmaElectronicaCampos() {
    this.editarRegistroFirmaElectronicaCampos = false;
    this.editarRegistroFirmaElectronicaCopiar = false;
  }
  EliminarRegistroFirmaElectronicaCampos() {
    if (this.detalleSeleccionadoFirmaElectronicaCampos > 0) {
      let listaCamposEditar = this.listaDatosFirmaElectronica.filter(x => x.id === this.itemFirmaElectronicaSeleccionado.id)[0];
      this.RecargarListaCamposFirmaElectronica(listaCamposEditar.listaCampos);
    }
  }
  NuevoFirmaElectronicaCopiar() {
    this.editarRegistroFirmaElectronicaCampos = false;
    this.editarRegistroFirmaElectronicaCopiar = true;
    this.IniciarFormularioFirmaElectronicaCampos();
  }
  ListaCamposFirmaElectronica(): Maestro_ProductosFirmaElectronica[] {
    return this.listaDatosFirmaElectronica.filter(x => x.id !== this.itemFirmaElectronicaSeleccionado.id);
  }
  //**************************************/
  //firma electronica campos ubicacion
  //**************************************/
  IniciarFormularioFirmaElectronicaCamposUbicacion() {
    this.formFirmaElectronicaCamposUbicacion = this.fb.group({
      'id': new FormControl(0),
      'idCampo': new FormControl(0),
      'posicionX': new FormControl(0, [Validators.min(1)]),
      'posicionY': new FormControl(0, [Validators.min(1)]),
      'ancho': new FormControl(0, [Validators.min(1)]),
      'tamanoLetra': new FormControl(0, [Validators.min(1)]),
      'colorTexto': new FormControl(''),
    });

    this.EstablecerFirmaElectronicaRequeridosCamposUbicacion();
  }
  EstablecerFirmaElectronicaRequeridosCamposUbicacion() {
    
  }
  AbrirCamposFirmaElectronicaUbicacion(firmaElectronicaEditarCampos: Maestro_ProductosFirmaElectronicaCampos) {
    console.log('AbrirCamposFirmaElectronicaUbicacion', firmaElectronicaEditarCampos);
    this.editarRegistroFirmaElectronicaCamposUbicacion = false;
    this.itemFirmaElectronicaCamposSeleccionado = firmaElectronicaEditarCampos;
    this.dataSourceFirmaElectronicacamposubicacion = new MatTableDataSource(firmaElectronicaEditarCampos.listaUbicaciones);
    setTimeout(() => {
      this.dataSourceFirmaElectronicacamposubicacion.paginator = this.paginatorfirmaeletronicacamposubicacion;
      this.dataSourceFirmaElectronicacamposubicacion.sort = this.sortfirmaelectronicacamposubicacion;
    });

    this.modal.open(this._ModalFirmaElectronicaCamposUbicacion, {
      height: '650px',
      width: '850px'
    });
  }
  NuevoFirmaElectronicaCampoUbicacion() {
    this.editarRegistroFirmaElectronicaCamposUbicacion = true;
    this.IniciarFormularioFirmaElectronicaCamposUbicacion();
    let itemFirmaEditar = this.listaDatosFirmaElectronica.filter(x => x.id === this.itemFirmaElectronicaSeleccionado.id)[0];
    let listaCampo = itemFirmaEditar.listaCampos.filter(x => x.id === this.itemFirmaElectronicaCamposSeleccionado.id)[0];
    this.formFirmaElectronicaCamposUbicacion.get('id').setValue((listaCampo.listaUbicaciones.length + 1));
  }
  EditarFirmaElectronicaCampoUbicacion(firmaElectronicaEditar: Maestro_ProductosFirmaElectronicaCamposUbicacion) {
    this.editarRegistroFirmaElectronicaCamposUbicacion = true;
    this.IniciarFormularioFirmaElectronicaCamposUbicacion();
    this.formFirmaElectronicaCamposUbicacion.setValue(firmaElectronicaEditar);
  }
  EliminarFirmaElectronicaCampoUbicacion(firmaElectronicaEditar: Maestro_ProductosFirmaElectronicaCamposUbicacion) {
    this.detalleSeleccionadoFirmaElectronicaCamposUbicacion = firmaElectronicaEditar.id;
    this.codigoAccion = 'eliminarFirmaElectronicaCamposUbicacion';
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  GuardarFirmaElectronicaCampoUbicacion() {
    if (this.formFirmaElectronicaCamposUbicacion.valid) {
      this.editarRegistroFirmaElectronicaCamposUbicacion = false;
      let itemFirmaEditar = this.listaDatosFirmaElectronica.filter(x => x.id === this.itemFirmaElectronicaSeleccionado.id)[0];
      let listaCampo = itemFirmaEditar.listaCampos.filter(x => x.id === this.itemFirmaElectronicaCamposSeleccionado.id)[0];

      console.log('GuardarFirmaElectronicaCampo-Antes', listaCampo.listaUbicaciones);
      if (listaCampo.listaUbicaciones.filter(x => x.id === this.formFirmaElectronicaCamposUbicacion.get('id').value).length > 0) {
        let parametroActualizar = listaCampo.listaUbicaciones.filter(x => x.id === this.formFirmaElectronicaCamposUbicacion.get('id').value)[0];
        parametroActualizar.id = this.formFirmaElectronicaCamposUbicacion.get('id').value;
        parametroActualizar.idCampo = this.formFirmaElectronicaCamposUbicacion.get('idCampo').value;
        parametroActualizar.posicionX = this.formFirmaElectronicaCamposUbicacion.get('posicionX').value;
        parametroActualizar.posicionY = this.formFirmaElectronicaCamposUbicacion.get('posicionY').value;
        parametroActualizar.ancho = this.formFirmaElectronicaCamposUbicacion.get('ancho').value;
        parametroActualizar.tamanoLetra = this.formFirmaElectronicaCamposUbicacion.get('tamanoLetra').value;
        parametroActualizar.colorTexto = this.formFirmaElectronicaCamposUbicacion.get('colorTexto').value;
      } else {
        listaCampo.listaUbicaciones.push(this.formFirmaElectronicaCamposUbicacion.value);
      }

      console.log('GuardarFirmaElectronicaCampo-Despues', listaCampo.listaUbicaciones);
      
      this.dataSourceFirmaElectronicacamposubicacion = new MatTableDataSource(listaCampo.listaUbicaciones);
      setTimeout(() => {
        this.dataSourceFirmaElectronicacamposubicacion.paginator = this.paginatorfirmaeletronicacamposubicacion;
        this.dataSourceFirmaElectronicacamposubicacion.sort = this.sortfirmaelectronicacamposubicacion;
      });
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.formFirmaElectronicaCamposUbicacion);
    }
  }
  CancelarEditarFirmaElectronicaCamposUbicacion() {
    this.editarRegistroFirmaElectronicaCamposUbicacion = false;
  }
  EliminarRegistroFirmaElectronicaCamposUbicacion() {
    if (this.detalleSeleccionadoFirmaElectronicaCamposUbicacion > 0) {
      let itemFirma = this.listaDatosFirmaElectronica.filter(x => x.id === this.itemFirmaElectronicaSeleccionado.id)[0];
      let itemCampo = itemFirma.listaCampos.filter(x => x.id === this.itemFirmaElectronicaCamposSeleccionado.id)[0];
      itemCampo.listaUbicaciones = itemCampo.listaUbicaciones.filter(x => x.id !== this.detalleSeleccionadoFirmaElectronicaCamposUbicacion);
      this.dataSourceFirmaElectronicacamposubicacion = new MatTableDataSource(itemCampo.listaUbicaciones);
      setTimeout(() => {
        this.dataSourceFirmaElectronicacamposubicacion.paginator = this.paginatorfirmaeletronicacamposubicacion;
        this.dataSourceFirmaElectronicacamposubicacion.sort = this.sortfirmaelectronicacamposubicacion;
      });
    }
  }
  //**************************************/
  CambioTipoFirma() {
    this.EstablecerFirmaElectronicaRequeridos();
  }
  CambioTipoCampo() {
    this.EstablecerFirmaElectronicaRequeridosCampos();
    this.formFirmaElectronicaCampos.get('campo').setValue('');
    this.formFirmaElectronicaCampos.get('descripcion').setValue('');
    if (!this.MostrarCodigoCampo()) {
      this.formFirmaElectronicaCampos.get('campo').setValue(this.formFirmaElectronicaCampos.get('tipoCampo').value);
      this.formFirmaElectronicaCampos.get('mostrar').setValue(false);
    }
  }
  //codigos activacion
  IniciarFormularioCodigosActivacion() {
    this.formCodigosActivacion = this.fb.group({
      'id': new FormControl(0),
      'codigo': new FormControl('', [Validators.required, Validators.maxLength(100)]),
      'habilitado': new FormControl(false),
    });
  }
  recargarListaCodigosActivacion() {
    this.dataSourceCodigosActivacion = new MatTableDataSource(this.listaDatosCodigosActivacion);
    setTimeout(() => {
      this.dataSourceCodigosActivacion.paginator = this.paginatorcodigos;
      this.dataSourceCodigosActivacion.sort = this.sortcodigos;
    });
  }
  NuevoCodigosActivacion() {
    this.editarRegistroCodigosActivacion = true;
    this.IniciarFormularioCodigosActivacion();
    this.formCodigosActivacion.get('id').setValue((this.listaDatosCodigosActivacion.length + 1) * -1);
  }
  EditarCodigosActivacion(codigosActivacionEditar: Maestro_ProductosCodigosActivacion) {
    this.editarRegistroCodigosActivacion = true;
    this.IniciarFormularioCodigosActivacion();
    this.formCodigosActivacion.setValue(codigosActivacionEditar);
  }
  EliminarCodigosActivacion(codigosActivacionEditar: Maestro_ProductosCodigosActivacion) {
    this.detalleSeleccionadoCodigosActivacion = codigosActivacionEditar.id;
    this.codigoAccion = 'eliminarCodigosActivacion';
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  GuardarCodigosActivacion() {
    if (this.formCodigosActivacion.valid) {
      this.editarRegistroCodigosActivacion = false;
      if (this.listaDatosCodigosActivacion.filter(x => x.id === this.formCodigosActivacion.get('id').value).length > 0) {
        let parametroActualizar = this.listaDatosCodigosActivacion.filter(x => x.id === this.formCodigosActivacion.get('id').value)[0];
        parametroActualizar.codigo = this.formCodigosActivacion.get('codigo').value;
        parametroActualizar.habilitado = this.formCodigosActivacion.get('habilitado').value;
      } else {
        this.listaDatosCodigosActivacion.push(this.formCodigosActivacion.value);
      }
      
      this.recargarListaCodigosActivacion();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.formCodigosActivacion);
    }
  }
  CancelarEditarCodigosActivacion() {
    this.editarRegistroCodigosActivacion = false;
  }
  EliminarRegistroCodigosActivacion() {
    if (this.detalleSeleccionadoCodigosActivacion > 0) {
      this.listaDatosCodigosActivacionEliminar.push(this.listaDatosCodigosActivacion.filter(x => x.id === this.detalleSeleccionadoCodigosActivacion)[0]);
    }
    let listaNueva: Maestro_ProductosCodigosActivacion[] = [];
    for (let index = 0; index < this.listaDatosCodigosActivacion.length; index++) {
      if (this.listaDatosCodigosActivacion[index].id !== this.detalleSeleccionadoCodigosActivacion) {
        listaNueva.push(this.listaDatosCodigosActivacion[index]);
      }
    }
    this.listaDatosCodigosActivacion = listaNueva;
    this.recargarListaCodigosActivacion();
  }
  AbrirCargarArchivoActualizacion() {
    if (this.utilitariosService.VerificarContieneDatosNumerico(this.form.get('id')?.value)) {
      this.AbrirCargarArchivo();
    } else {
      this.Guardar('CARGACODIGOS');
    }
  }
  AbrirCargarArchivo() {
    this._uploadFile.nativeElement.value = '';
    this._uploadFile.nativeElement.click();
  }
  ArchivoSeleccionar(_Archivos: File[]) {
    this.datosArchivo = new FormData();
    this.datosArchivo.append('formFiles', _Archivos[0]);

    this.mostrarCargando = true;
    this.datosServices.ConsultarCodigosCargar(this.datosArchivo, this.form.get('aliado')?.value, this.form.get('id')?.value)
            .subscribe((resp: RespuestaGenerica) =>{
              this.utilitariosService.MensajeToast(resp.mensaje);
              this.mostrarCargando = false;
              
              this.ConsultarRegistrosCodigosActivacion();
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  //expedientes
  IniciarFormularioExpedientes() {
    this.formExpedientes = this.fb.group({
      'id': new FormControl(0),
      'idServicio': new FormControl(0, [Validators.min(1)]),
      'servicio': new FormControl(''),
      'idSubServicio': new FormControl(0, [Validators.min(1)]),
      'subServicio': new FormControl(''),
      'eventosIncluidos': new FormControl(''),
      'montoMaximoCobertura': new FormControl(''),
      'habilitado': new FormControl(false),
    });
  }
  recargarListaExpedientes() {
    this.dataSourceExpedientes = new MatTableDataSource(this.listaDatosExpedientes);
    setTimeout(() => {
      this.dataSourceExpedientes.paginator = this.paginatoredades;
      this.dataSourceExpedientes.sort = this.sortedades;
    });
  }
  NuevoExpedientes() {
    this.editarRegistroExpedientes = true;
    this.IniciarFormularioExpedientes();
    this.formExpedientes.get('id').setValue((this.listaDatosExpedientes.length + 1) * -1);
    this.formExpedientes.get('habilitado').setValue(true);
  }
  EditarExpedientes(expedientesEditar: Maestro_ProductosExpedientes) {
    this.editarRegistroExpedientes = true;
    this.IniciarFormularioExpedientes();
    this.formExpedientes.setValue(expedientesEditar);
    this.ObtenerListaSubServicio();
  }
  EliminarExpedientes(expedientesEditar: Maestro_ProductosExpedientes) {
    this.detalleSeleccionadoExpedientes = expedientesEditar.id;
    this.codigoAccion = 'eliminarExpediente';
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  GuardarExpediente() {
    if (this.formExpedientes.valid) {
      this.editarRegistroExpedientes = false;
      this.formExpedientes.get('servicio').setValue(this.listasServiciosExpedientes.filter(x => x.id === this.formExpedientes.get('idServicio').value)[0].descripcion);
      this.formExpedientes.get('subServicio').setValue(this.listasSubServiciosExpedientes.filter(x => x.id === this.formExpedientes.get('idSubServicio').value && x.dependienciaId === this.formExpedientes.get('idServicio').value)[0].descripcion);

      if (this.listaDatosExpedientes.filter(x => x.id === this.formExpedientes.get('id').value).length > 0) {
        let parametroActualizar = this.listaDatosExpedientes.filter(x => x.id === this.formExpedientes.get('id').value)[0];
        parametroActualizar.idServicio = this.formExpedientes.get('idServicio').value;
        parametroActualizar.servicio = this.formExpedientes.get('servicio').value;
        parametroActualizar.idSubServicio = this.formExpedientes.get('idSubServicio').value;
        parametroActualizar.subServicio = this.formExpedientes.get('subServicio').value;
        parametroActualizar.eventosIncluidos = this.formExpedientes.get('eventosIncluidos').value;
        parametroActualizar.montoMaximoCobertura = this.formExpedientes.get('montoMaximoCobertura').value;
        parametroActualizar.habilitado = this.formExpedientes.get('habilitado').value;
      } else {
        this.listaDatosExpedientes.push(this.formExpedientes.value);
      }
      
      this.recargarListaExpedientes();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.formExpedientes);
    }
  }
  CancelarEditarExpedientes() {
    this.editarRegistroExpedientes = false;
  }
  EliminarRegistroExpedientes() {
    if (this.detalleSeleccionadoExpedientes > 0) {
      this.listaDatosExpedientesEliminar.push(this.listaDatosExpedientes.filter(x => x.id === this.detalleSeleccionadoExpedientes)[0]);
    }
    let listaNueva: Maestro_ProductosExpedientes[] = [];
    for (let index = 0; index < this.listaDatosExpedientes.length; index++) {
      if (this.listaDatosExpedientes[index].id !== this.detalleSeleccionadoExpedientes) {
        listaNueva.push(this.listaDatosExpedientes[index]);
      }
    }
    this.listaDatosExpedientes = listaNueva;
    this.recargarListaExpedientes();
  }
  //estados dias
  IniciarFormularioEstadosDias() {
    this.formEstadosDias = this.fb.group({
      'id': new FormControl(0),
      'idProducto': new FormControl(0),
      'diaMes': new FormControl(0),
      'idEstado': new FormControl(0, [Validators.min(1)]),
      'activarSiguienteMes': new FormControl(false),
      'diaMesActivar': new FormControl(0),
      'estado': new FormControl(''),
    });
  }
  recargarListaEstadosDias() {
    this.dataSourceEstadosDias = new MatTableDataSource(this.listaDatosEstadosDias);
    setTimeout(() => {
      this.dataSourceEstadosDias.paginator = this.paginatoredades;
      this.dataSourceEstadosDias.sort = this.sortedades;
    });
  }
  NuevoEstadosDias() {
    this.editarRegistroEstadosDias = true;
    this.IniciarFormularioEstadosDias();
    this.formEstadosDias.get('id').setValue((this.listaDatosEstadosDias.length + 1) * -1);
  }
  EditarEstadosDias(EstadosDiasEditar: Maestro_ProductosEstadosDias) {
    this.editarRegistroEstadosDias = true;
    this.IniciarFormularioEstadosDias();
    this.formEstadosDias.setValue(EstadosDiasEditar);
  }
  EliminarEstadosDias(EstadosDiasEditar: Maestro_ProductosEstadosDias) {
    this.detalleSeleccionadoEstadosDias = EstadosDiasEditar.id;
    this.codigoAccion = 'eliminarEstadosDias';
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  GuardarEstadosDias() {
    if (this.formEstadosDias.valid) {
      this.editarRegistroEstadosDias = false;

      this.formEstadosDias.get('estado').setValue(this.listasEstadosConfiguracion.filter(x => x.id === this.formEstadosDias.get('idEstado').value)[0].descripcion);

      if (this.listaDatosEstadosDias.filter(x => x.id === this.formEstadosDias.get('id').value).length > 0) {
        let parametroActualizar = this.listaDatosEstadosDias.filter(x => x.id === this.formEstadosDias.get('id').value)[0];
        parametroActualizar.idProducto = this.formEstadosDias.get('idProducto').value;
        parametroActualizar.diaMes = this.formEstadosDias.get('diaMes').value;
        parametroActualizar.idEstado = this.formEstadosDias.get('idEstado').value;
        parametroActualizar.activarSiguienteMes = this.formEstadosDias.get('activarSiguienteMes').value;
        parametroActualizar.diaMesActivar = this.formEstadosDias.get('diaMesActivar').value;
        parametroActualizar.estado = this.formEstadosDias.get('estado').value;
      } else {
        this.listaDatosEstadosDias.push(this.formEstadosDias.value);
      }
      
      this.recargarListaEstadosDias();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.formEstadosDias);
    }
  }
  CancelarEditarEstadosDias() {
    this.editarRegistroEstadosDias = false;
  }
  EliminarRegistroEstadosDias() {
    if (this.detalleSeleccionadoEstadosDias > 0) {
      this.listaDatosEstadosDiasEliminar.push(this.listaDatosEstadosDias.filter(x => x.id === this.detalleSeleccionadoEstadosDias)[0]);
    }
    let listaNueva: Maestro_ProductosEstadosDias[] = [];
    for (let index = 0; index < this.listaDatosEstadosDias.length; index++) {
      if (this.listaDatosEstadosDias[index].id !== this.detalleSeleccionadoEstadosDias) {
        listaNueva.push(this.listaDatosEstadosDias[index]);
      }
    }
    this.listaDatosEstadosDias = listaNueva;
    this.recargarListaEstadosDias();
  }
  CargarArchivoFirmaElectronica(itemFirmaElectronicaSeleccionado: Maestro_ProductosFirmaElectronica) {
    this.itemFirmaElectronicaSeleccionado = itemFirmaElectronicaSeleccionado;
    this._cargararchivofirmaelectronica.MostrarSeleccionArchivo();
  }
  ArchivoSeleccionado(archivoSeleccionado: any) {
    console.log('ArchivoSeleccionado', archivoSeleccionado);
    if (archivoSeleccionado.subioArchivo) {
      this.ArchivoSeleccionadoInterno(archivoSeleccionado, this.itemFirmaElectronicaSeleccionado.id);
    }
  }
  ArchivoSeleccionadoInterno(archivoSeleccionado: any, idItemSeleccionado: number) {
    console.log('ArchivoSeleccionadoInterno', archivoSeleccionado);
    this.mostrarCargando = true;
    this.datosArchivoFirmaElectronica = archivoSeleccionado.archivo;
    this.datosServices.SubirArchivoFirmaElectronica(this.datosArchivoFirmaElectronica, this.form.get('aliado')?.value, this.form.get('id')?.value, idItemSeleccionado)
            .subscribe((resp: RespuestaGenerica) =>{
              if (!resp.procesoExitoso) {
                this.utilitariosService.MensajeToast(resp.mensaje);
                this.mostrarCargando = false;
              } else {
                this.mostrarCargando = false;
                this.ConsultarRegistrosFirmaElectronica();
              }
            },
            (error: Error) => {
              this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
              this.mostrarCargando = false;
              this.cd.detectChanges();
            },
            () => this.cd.detectChanges());
  }
  DescargarArchivoFirmaElectronica(firmaElectronicaEditar: Maestro_ProductosFirmaElectronica) {
    if (this.utilitariosService.VerificarContieneDatosNumerico(firmaElectronicaEditar.id)) {
      this.mostrarCargando = true;
      this.datosServices.DescargarArchivoFirmaElectronica(this.datosArchivoFirmaElectronica, this.form.get('aliado')?.value, this.form.get('id')?.value, firmaElectronicaEditar.id)
      .subscribe((resp: any) =>{
        let nombreArchivoDescarga: string = firmaElectronicaEditar.rutaArchivoFirmaElectronica;
        let nombresArchivoSeparado = nombreArchivoDescarga.split('.');
        nombreArchivoDescarga = nombreArchivoDescarga.replace(`.${nombresArchivoSeparado[nombresArchivoSeparado.length - 1]}`, '');
        nombreArchivoDescarga += '.pdf';

        let dataType = resp.type;
        let binaryData = [];
        binaryData.push(resp);
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
        downloadLink.setAttribute('download', nombreArchivoDescarga);
        document.body.appendChild(downloadLink);
        downloadLink.click();

        this.mostrarCargando = false;
      },
      (error: Error) => {
        this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
        this.mostrarCargando = false;
        this.cd.detectChanges();
      },
      () => this.cd.detectChanges());
    } else {
      this.utilitariosService.MensajeToast('Aun no se ha subido el documento para descargar');
    }
  }
  MostrarListaTopicos(): boolean {
    return this.formFirmaElectronicaCampos.get('tipoCampo')?.value === 'LISTATOPICO';
  }
  MostrarListaValores(): boolean {
    return this.formFirmaElectronicaCampos.get('tipoCampo')?.value === 'LISTAINTERNA';
  }
  MostrarValorCampo(): boolean {
    return this.formFirmaElectronicaCampos.get('tipoCampo')?.value === 'VALOR_FIJO' 
      || this.formFirmaElectronicaCampos.get('tipoCampo')?.value === 'CALCULADO'
      || this.formFirmaElectronicaCampos.get('tipoCampo')?.value === 'SI/NO_2';
  }
  MostrarCodigoCampo(): boolean {
    return this.formFirmaElectronicaCampos.get('tipoCampo')?.value === 'TEXTO'
      || this.formFirmaElectronicaCampos.get('tipoCampo')?.value === 'NUMERICO'
      || this.formFirmaElectronicaCampos.get('tipoCampo')?.value === 'FECHA'
      || this.formFirmaElectronicaCampos.get('tipoCampo')?.value === 'SI/NO'
      || this.formFirmaElectronicaCampos.get('tipoCampo')?.value === 'SI/NO_2'
      || this.formFirmaElectronicaCampos.get('tipoCampo')?.value === 'LISTAINTERNA'
      || this.formFirmaElectronicaCampos.get('tipoCampo')?.value === 'LISTATOPICO';
  }
  RecargarListaCamposFirmaElectronica(listaCamposMostrar: Maestro_ProductosFirmaElectronicaCampos[]) {
    let listaAsignar = JSON.parse(JSON.stringify(listaCamposMostrar));
    listaAsignar = listaAsignar.sort((a, b) => {
      if (a.mostrar !== b.mostrar) {
        return a.mostrar ? -1 : 1;
      }
      
      if (a.mostrar && b.mostrar) {
        // Si las edades son iguales, comparar por 'name'
        if (a.orden > b.orden) {
            return 1; // Ordenar 'name' en orden descendente
        } else if (a.orden < b.orden) {
            return -1; // Ordenar 'name' en orden descendente
        } else {
            return 0; // Los nombres son iguales
        }
      } else {
        // Si las edades son iguales, comparar por 'name'
        if (a.tipoCampo > b.tipoCampo) {
          return 1; // Ordenar 'name' en orden descendente
        } else if (a.tipoCampo < b.tipoCampo) {
          return -1; // Ordenar 'name' en orden descendente
        } else {
          return 0; // Los nombres son iguales
        }
      }
    });

    this.dataSourceFirmaElectronicacampos = new MatTableDataSource(listaAsignar);
    setTimeout(() => {
      this.dataSourceFirmaElectronicacampos.paginator = this.paginatorfirmaeletronicacampos;
      this.dataSourceFirmaElectronicacampos.sort = this.sortfirmaelectronicacampos;
    });
  }
  MostrarMesesCobro(): boolean {
    if (this.utilitariosService.VerificarContieneDatos(this.formPlazos)) {
      return !this.formPlazos.get('sinMesesCobro').value;
    }
    return true;
  }
  Cambio_Comercializacion() {
    this.ConsultarDetalleComercializacion();  
  }
  ConsultarDetalleComercializacion() {
    let codigoComercializacion: string = '';
    if (this.listasComercializacion.filter(x => x.id === this.form.get('comercializacion').value).length > 0) {
      codigoComercializacion = this.listasComercializacion.filter(x => x.id === this.form.get('comercializacion').value)[0].codigo;
    }

    console.log('ConsultarDetalleComercializacion', this.parametrosPrincipal.id, codigoComercializacion);
    if (!this.utilitariosService.VerificarContieneDatosNumerico(this.parametrosPrincipal.id) && this.utilitariosService.VerificarContieneDatosTexto(codigoComercializacion)) {
      this.mostrarCargando = true;
  
      let parametrosConsulta = this.fb.group({
        codigo: [''],
        tipoConfiguracion: ['PROGRAMA']
      });
  
      parametrosConsulta.get('codigo').setValue(codigoComercializacion);
      
      this.datosConfiguracionComercializacion.ConsultarCodigosTipoConfiguracion(parametrosConsulta.value)
        .subscribe((resp: Maestro_ConfiguracionComercializacionDetalle[]) => {
          
          if (this.utilitariosService.VerificarContieneDatosLista(resp)) {
            for (let index = 0; index < resp.length; index++) {
              const itemAsignacion = resp[index];

              if (itemAsignacion.parametroConfiguracion === 'REGISTRARBENEFICIARIO') {
                if (itemAsignacion.valorConfiguracion === 'SI') {
                  this.form.get('registrarBeneficiarios').setValue(true);  
                }
              } else if (itemAsignacion.parametroConfiguracion === 'BENEFICIARIOREQUERIDO') {
                if (itemAsignacion.valorConfiguracion === 'SI') {
                  this.form.get('beneficiariosrequeridos').setValue(true);  
                }
              } else if (itemAsignacion.parametroConfiguracion === 'NOTIFICACIONSMS') {
                if (itemAsignacion.valorConfiguracion === 'SI') {
                  this.form.get('notificacionSMS').setValue(true);  
                }
              } else if (itemAsignacion.parametroConfiguracion === 'NOTIFICACIONEMAIL') {
                if (itemAsignacion.valorConfiguracion === 'SI') {
                  this.form.get('notificacionEmail').setValue(true);  
                }
              } else if (itemAsignacion.parametroConfiguracion === 'REGISTRARESTADO') {
                if (itemAsignacion.valorConfiguracion === 'SI') {
                  this.form.get('registrarEstado').setValue(true);  
                }
              } else if (itemAsignacion.parametroConfiguracion === 'MANEJAFECHANACIMIENTO') {
                if (itemAsignacion.valorConfiguracion === 'SI') {
                  this.form.get('manejaFechaNacimiento').setValue(true);  
                }
              } else if (itemAsignacion.parametroConfiguracion === 'MANEJADOMICILIO') {
                if (itemAsignacion.valorConfiguracion === 'SI') {
                  this.form.get('manejaDomicilio').setValue(true);  
                }
              } else if (itemAsignacion.parametroConfiguracion === 'MANEJAOBSERVACIONES') {
                if (itemAsignacion.valorConfiguracion === 'SI') {
                  this.form.get('manejaObservaciones').setValue(true);  
                }
              } else if (itemAsignacion.parametroConfiguracion === 'MANEJAFIRMAELECTRONICA') {
                if (itemAsignacion.valorConfiguracion === 'SI') {
                  this.form.get('firmaElectronica').setValue(true);  
                }
              } else if (itemAsignacion.parametroConfiguracion === 'OPERACIONESREEMBOLSO') {
                if (itemAsignacion.valorConfiguracion === 'SI') {
                  this.form.get('operacionesReembolso').setValue(true);  
                }
              } else if (itemAsignacion.parametroConfiguracion === 'SOLICITARTOMADOR') {
                if (itemAsignacion.valorConfiguracion === 'SI') {
                  this.form.get('tomador').setValue(true);  
                }
              } else if (itemAsignacion.parametroConfiguracion === 'DUPLICARTITULAR') {
                if (itemAsignacion.valorConfiguracion === 'SI') {
                  this.form.get('duplicarTitular').setValue(true);  
                }
              } else if (itemAsignacion.parametroConfiguracion === 'ESTADODEPENDIENTEFECHA') {
                if (itemAsignacion.valorConfiguracion === 'SI') {
                  this.form.get('estadoDependienteFecha').setValue(true);  
                }
              } else if (itemAsignacion.parametroConfiguracion === 'PERMITEEDITAR') {
                if (itemAsignacion.valorConfiguracion === 'SI') {
                  this.form.get('permiteEditar').setValue(true);  
                }
              } else if (itemAsignacion.parametroConfiguracion === 'PROGRAMACIONPRECIOS') {
                if (itemAsignacion.valorConfiguracion === 'SI') {
                  this.form.get('programacionPrecios').setValue(true);  
                }
              }
            }
          }

          this.mostrarCargando = false;
        },
        (error: Error) => {
          this.utilitariosService.ObtenerMensajeErrorRespuesta(error);
          this.mostrarCargando = false;
          this.cd.detectChanges();
        },
        () => this.cd.detectChanges());
    }
  }
  //campos
  IniciarFormularioCampos() {
    this.formCampos = this.fb.group({
      'id': new FormControl(0),
      'descripcion': new FormControl('', [Validators.required, Validators.maxLength(100)]),
      'mostrar': new FormControl(false),
      'habilitado': new FormControl(false),
    });
  }
  recargarListaCampos() {
    this.dataSourceCampos = new MatTableDataSource(this.listaDatosCampos);
    setTimeout(() => {
      this.dataSourceCampos.paginator = this.paginatorcampos;
      this.dataSourceCampos.sort = this.sortcampos;
    });
  }
  NuevoCampos() {
    this.editarRegistroCampos = true;
    this.IniciarFormularioCampos();
    this.formCampos.get('id').setValue((this.listaDatosCampos.length + 1) * -1);
  }
  EditarCampos(camposEditar: Maestro_ProductosCampos) {
    this.editarRegistroCampos = true;
    this.IniciarFormularioCampos();
    this.formCampos.setValue(camposEditar);
  }
  EliminarCampos(CamposEditar: Maestro_ProductosCampos) {
    this.detalleSeleccionadoCampos = CamposEditar.id;
    this.codigoAccion = 'eliminarCampos';
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  GuardarCampos() {
    if (this.formCampos.valid) {
      this.editarRegistroCampos = false;
      if (this.listaDatosCampos.filter(x => x.id === this.formCampos.get('id').value).length > 0) {
        let parametroActualizar = this.listaDatosCampos.filter(x => x.id === this.formCampos.get('id').value)[0];
        parametroActualizar.descripcion = this.formCampos.get('descripcion').value;
        parametroActualizar.mostrar = this.formCampos.get('mostrar').value;
        parametroActualizar.habilitado = this.formCampos.get('habilitado').value;
      } else {
        this.listaDatosCampos.push(this.formCampos.value);
      }
      
      this.recargarListaCampos();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.formCampos);
    }
  }
  CancelarEditarCampos() {
    this.editarRegistroCampos = false;
  }
  EliminarRegistroCampos() {
    if (this.detalleSeleccionadoCampos > 0) {
      this.listaDatosCamposEliminar.push(this.listaDatosCampos.filter(x => x.id === this.detalleSeleccionadoCampos)[0]);
    }
    let listaNueva: Maestro_ProductosCampos[] = [];
    for (let index = 0; index < this.listaDatosCampos.length; index++) {
      if (this.listaDatosCampos[index].id !== this.detalleSeleccionadoCampos) {
        listaNueva.push(this.listaDatosCampos[index]);
      }
    }
    this.listaDatosCampos = listaNueva;
    this.recargarListaCampos();
  }
  //campos beneficiarios
  IniciarFormularioCamposBeneficiarios() {
    this.formCamposBeneficiarios = this.fb.group({
      'id': new FormControl(0),
      'codigo': new FormControl('', [Validators.required, Validators.maxLength(100)]),
      'descripcion': new FormControl('', [Validators.required, Validators.maxLength(100)]),
      'origenPadre': new FormControl(''),
      'orden': new FormControl(0),
    });
  }
  recargarListaCamposBeneficiarios() {
    this.dataSourceCamposBeneficiarios = new MatTableDataSource(this.listaDatosCamposBeneficiarios);
    setTimeout(() => {
      this.dataSourceCamposBeneficiarios.paginator = this.paginatorcamposbeneficiarios;
      this.dataSourceCamposBeneficiarios.sort = this.sortcamposbeneficiarios;
    });
  }
  NuevoCamposBeneficiarios() {
    this.editarRegistroCamposBeneficiarios = true;
    this.IniciarFormularioCamposBeneficiarios();
    this.formCamposBeneficiarios.get('id').setValue((this.listaDatosCamposBeneficiarios.length + 1) * -1);
  }
  EditarCamposBeneficiarios(camposEditar: Maestro_ProductosCamposBeneficiarios) {
    this.editarRegistroCamposBeneficiarios = true;
    this.IniciarFormularioCamposBeneficiarios();
    this.formCamposBeneficiarios.setValue(camposEditar);
  }
  EliminarCamposBeneficiarios(CamposEditar: Maestro_ProductosCamposBeneficiarios) {
    this.detalleSeleccionadoCamposBeneficiarios = CamposEditar.id;
    this.codigoAccion = 'eliminarCamposBeneficiarios';
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  GuardarCamposBeneficiarios() {
    if (this.formCamposBeneficiarios.valid) {
      this.editarRegistroCamposBeneficiarios = false;
      if (this.listaDatosCamposBeneficiarios.filter(x => x.id === this.formCamposBeneficiarios.get('id').value).length > 0) {
        let parametroActualizar = this.listaDatosCamposBeneficiarios.filter(x => x.id === this.formCamposBeneficiarios.get('id').value)[0];
        parametroActualizar.codigo = this.formCamposBeneficiarios.get('codigo').value;
        parametroActualizar.descripcion = this.formCamposBeneficiarios.get('descripcion').value;
        parametroActualizar.origenPadre = this.formCamposBeneficiarios.get('origenPadre').value;
        parametroActualizar.orden = this.formCamposBeneficiarios.get('orden').value;
      } else {
        this.listaDatosCamposBeneficiarios.push(this.formCamposBeneficiarios.value);
      }
      
      this.recargarListaCamposBeneficiarios();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.formCampos);
    }
  }
  CancelarEditarCamposBeneficiarios() {
    this.editarRegistroCamposBeneficiarios = false;
  }
  EliminarRegistroCamposBeneficiarios() {
    if (this.detalleSeleccionadoCamposBeneficiarios > 0) {
      this.listaDatosCamposBeneficiariosEliminar.push(this.listaDatosCamposBeneficiarios.filter(x => x.id === this.detalleSeleccionadoCamposBeneficiarios)[0]);
    }
    let listaNueva: Maestro_ProductosCamposBeneficiarios[] = [];
    for (let index = 0; index < this.listaDatosCamposBeneficiarios.length; index++) {
      if (this.listaDatosCamposBeneficiarios[index].id !== this.detalleSeleccionadoCamposBeneficiarios) {
        listaNueva.push(this.listaDatosCamposBeneficiarios[index]);
      }
    }
    this.listaDatosCamposBeneficiarios = listaNueva;
    this.recargarListaCampos();
  }
  MostrarDescripcionCampo(codigoCampo: string): string {
    if (this.utilitariosService.VerificarContieneDatosLista(this.listasCampos)
      && this.utilitariosService.VerificarContieneDatosTexto(codigoCampo)) {
      if (this.listasCampos.filter(x => x.codigo === codigoCampo).length > 0) {
        return this.listasCampos.filter(x => x.codigo === codigoCampo)[0].descripcion;
      }
    }
    return codigoCampo;
  }
  MostrarDescripcionCampoBeneficiarios(codigoCampo: string): string {
    if (this.utilitariosService.VerificarContieneDatosLista(this.listasCamposBeneficiarios)
      && this.utilitariosService.VerificarContieneDatosTexto(codigoCampo)) {
      if (this.listasCamposBeneficiarios.filter(x => x.codigo === codigoCampo).length > 0) {
        return this.listasCamposBeneficiarios.filter(x => x.codigo === codigoCampo)[0].descripcion;
      }
    }
    return codigoCampo;
  }
  //notificaciones
  IniciarFormularioNotificaciones() {
    this.formNotificaciones = this.fb.group({
      id: [0],
      idProducto: [0],
      nombreProducto: [''],
      tipoProceso: ['', [Validators.required]],
      descripcionTipoProceso: [''],
      enviarSMS: [true],
      smsTexto: [''],
      enviarEmail: [true],
      emailFrom: [''],
      emailReplyTo: [''],
      emailSubject: [''],
      emailMensaje: [''],
      emailMensajeMostrar: [''],
      activo: [true]
    });

    this.EstablecerValidacionesNotificaciones();

    this.formNotificaciones.get('enviarSMS').valueChanges.subscribe((valorNuevo) => {
      let validatorsSMS = [];

      if (valorNuevo) {
        validatorsSMS.push(Validators.required);
        validatorsSMS.push(Validators.maxLength(260));
      }
      
      this.formNotificaciones.get('smsTexto').setValidators(validatorsSMS);
      this.formNotificaciones.get('smsTexto').updateValueAndValidity();
      
    });

    this.formNotificaciones.get('enviarEmail').valueChanges.subscribe((valorNuevo) => {
      let validatorsSoloRequerido = [];
      let validatorsEmail = [];

      if (valorNuevo) {
        validatorsEmail.push(Validators.required);
        validatorsEmail.push(Validators.maxLength(100));

        validatorsSoloRequerido.push(Validators.required);
      }
      
      this.formNotificaciones.get('emailFrom').setValidators(validatorsEmail);
      this.formNotificaciones.get('emailFrom').updateValueAndValidity();
      this.formNotificaciones.get('emailReplyTo').setValidators(validatorsEmail);
      this.formNotificaciones.get('emailReplyTo').updateValueAndValidity();
      this.formNotificaciones.get('emailSubject').setValidators(validatorsEmail);
      this.formNotificaciones.get('emailSubject').updateValueAndValidity();
      this.formNotificaciones.get('emailMensajeMostrar').setValidators(validatorsSoloRequerido);
      this.formNotificaciones.get('emailMensajeMostrar').updateValueAndValidity();
    });
  }
  EstablecerValidacionesNotificaciones() {
    let validatorsSMS = [];
    let validatorsSoloRequerido = [];
    let validatorsEmail = [];

    if (this.formNotificaciones.get('enviarSMS').value) {
      validatorsSMS.push(Validators.required);
      validatorsSMS.push(Validators.maxLength(260));
    }
    
    this.formNotificaciones.get('smsTexto').setValidators(validatorsSMS);
    this.formNotificaciones.get('smsTexto').updateValueAndValidity();

    if (this.formNotificaciones.get('enviarEmail').value) {
      validatorsEmail.push(Validators.required);
      validatorsEmail.push(Validators.maxLength(100));

      validatorsSoloRequerido.push(Validators.required);
    }
    
    this.formNotificaciones.get('emailFrom').setValidators(validatorsEmail);
    this.formNotificaciones.get('emailFrom').updateValueAndValidity();
    this.formNotificaciones.get('emailReplyTo').setValidators(validatorsEmail);
    this.formNotificaciones.get('emailReplyTo').updateValueAndValidity();
    this.formNotificaciones.get('emailSubject').setValidators(validatorsEmail);
    this.formNotificaciones.get('emailSubject').updateValueAndValidity();
    this.formNotificaciones.get('emailMensajeMostrar').setValidators(validatorsSoloRequerido);
    this.formNotificaciones.get('emailMensajeMostrar').updateValueAndValidity();
  }
  recargarListaNotificaciones() {
    this.dataSourceNotificaciones = new MatTableDataSource(this.listaDatosNotificaciones);
    setTimeout(() => {
      this.dataSourceNotificaciones.paginator = this.paginatornotificaciones;
      this.dataSourceNotificaciones.sort = this.sortnotificaciones;
    });
  }
  NuevoNotificaciones() {
    this.editarRegistroNotificaciones = true;
    this.IniciarFormularioNotificaciones();
    this.formNotificaciones.get('id').setValue((this.listaDatosNotificaciones.length + 1) * -1);
  }
  EditarNotificaciones(camposEditar: Maestro_ProductosNotificaciones) {
    this.editarRegistroNotificaciones = true;
    this.IniciarFormularioNotificaciones();
    this.formNotificaciones.setValue(camposEditar);
  }
  EliminarNotificaciones(CamposEditar: Maestro_ProductosNotificaciones) {
    this.detalleSeleccionadoNotificaciones = CamposEditar.id;
    this.codigoAccion = 'eliminarNotificaciones';
    this._appconfirmacion.MostrarMensajeConfirmacion();
  }
  GuardarNotificaciones() {
    if (this.formNotificaciones.valid) {
      if (this.formNotificaciones.get('tipoProceso').value === 'R') {
        this.formNotificaciones.get('descripcionTipoProceso').setValue('Registrar');
      } else if (this.formNotificaciones.get('tipoProceso').value === 'E') {
        this.formNotificaciones.get('descripcionTipoProceso').setValue('Cambiar estado');
      } else if (this.formNotificaciones.get('tipoProceso').value === 'A') {
        this.formNotificaciones.get('descripcionTipoProceso').setValue('Activación asistencia');
      } else if (this.formNotificaciones.get('tipoProceso').value === 'C') {
        this.formNotificaciones.get('descripcionTipoProceso').setValue('Registro carga masiva');
      } else if (this.formNotificaciones.get('tipoProceso').value === 'U') {
        this.formNotificaciones.get('descripcionTipoProceso').setValue('Firma electrónica código autorización');
      } else if (this.formNotificaciones.get('tipoProceso').value === 'F') {
        this.formNotificaciones.get('descripcionTipoProceso').setValue('Firma electrónica documento');
      }

      this.editarRegistroNotificaciones = false;
      if (this.listaDatosNotificaciones.filter(x => x.id === this.formNotificaciones.get('id').value).length > 0) {
        let parametroActualizar = this.listaDatosNotificaciones.filter(x => x.id === this.formNotificaciones.get('id').value)[0];
        parametroActualizar.nombreProducto = this.formNotificaciones.get('nombreProducto').value;
        parametroActualizar.tipoProceso = this.formNotificaciones.get('tipoProceso').value;
        parametroActualizar.descripcionTipoProceso = this.formNotificaciones.get('descripcionTipoProceso').value;
        parametroActualizar.enviarSMS = this.formNotificaciones.get('enviarSMS').value;
        parametroActualizar.smsTexto = this.formNotificaciones.get('smsTexto').value;
        parametroActualizar.enviarEmail = this.formNotificaciones.get('enviarEmail').value;
        parametroActualizar.emailFrom = this.formNotificaciones.get('emailFrom').value;
        parametroActualizar.emailReplyTo = this.formNotificaciones.get('emailReplyTo').value;
        parametroActualizar.emailSubject = this.formNotificaciones.get('emailSubject').value;
        parametroActualizar.emailMensaje = this.formNotificaciones.get('emailMensaje').value;
        parametroActualizar.activo = this.formNotificaciones.get('activo').value;
      } else {
        this.listaDatosNotificaciones.push(this.formNotificaciones.value);
      }
      
      this.recargarListaNotificaciones();
    } else {
      this.utilitariosService.MostrarErroresFormulario(this.formNotificaciones);
    }
  }
  CancelarEditarNotificaciones() {
    this.editarRegistroNotificaciones = false;
  }
  EliminarRegistroNotificaciones() {
    if (this.detalleSeleccionadoNotificaciones > 0) {
      this.listaDatosNotificacionesEliminar.push(this.listaDatosNotificaciones.filter(x => x.id === this.detalleSeleccionadoNotificaciones)[0]);
    }
    let listaNueva: Maestro_ProductosNotificaciones[] = [];
    for (let index = 0; index < this.listaDatosNotificaciones.length; index++) {
      if (this.listaDatosNotificaciones[index].id !== this.detalleSeleccionadoNotificaciones) {
        listaNueva.push(this.listaDatosNotificaciones[index]);
      }
    }
    this.listaDatosNotificaciones = listaNueva;
    this.recargarListaNotificaciones();
  }
  EditarContenidoHTML() {
    this._modificarplantillahtml.MostrarEdicionHtml(this.formNotificaciones.get('emailMensaje').value);
  }
  ConfirmoPlantillaHtml(textoHtml: string) {
    if (this.utilitariosService.VerificarContieneDatosTexto(textoHtml)) {
      this.formNotificaciones.get('emailMensaje').setValue(textoHtml);
      this.formNotificaciones.get('emailMensajeMostrar').setValue('Mensaje html...');
    }
  }
}
